import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';

import { Router } from '@angular/router';

import {
  AlertController,
  IonInfiniteScroll,
  LoadingController,
  ModalController,
  PopoverController,
  ToastController,
  IonContent,
} from '@ionic/angular';

import { CalendarModalOptions } from 'ion2-calendar';
import { ServicesProvider } from 'src/providers/services';
import { DatePipe } from '@angular/common';
import { InViewportMetadata } from 'ng-in-viewport';
import { FileUploadService } from 'src/providers/upload';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { AddCall } from 'src/providers/addvCall';
import { MediapopupPage } from '../mediapopup/mediapopup.page';
import { ReviewPage } from '../review/review.page';
import { TrainingcenterProgramPage } from './trainingcenter-program/trainingcenter-program.page';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { ViewmodelPage } from '../viewmodel/viewmodel.page';
import { Payment } from 'src/providers/payment';
import { RatingSortpagePage } from 'src/app/rating-sortpage/rating-sortpage.page';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import * as $ from 'jquery';
import { CommonService } from 'src/providers/common';
import { SuccessPage } from 'src/app/success/success.page';
import { knetPaymentDetailsPage } from '../success/knetPaymentDetails/knetPaymentDetails.page';
import { MediaElementPlayer } from 'mediaelement';
import { BookingdatemodalPage } from '../training-center/bookingdatemodal/bookingdatemodal.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { forEach } from 'jszip';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}

@Component({
  selector: 'app-training-center',
  templateUrl: './training-center.page.html',
  styleUrls: ['./training-center.page.scss'],
})
export class TrainingCenterPage implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChildren('newVdo') vdoPlayer: MediaElementPlayer;
  @Output() ChangeEventSports = new EventEmitter<string>();
  @Output() ChangeEvent = new EventEmitter<string>();
  currentPlaying = null;
  rescdamt: any;
  dealoroff: any;
  count: number = 0;
  doubleclickindex: any;
  likedPopUpStatus: any;
  conscenterid: any;
  storeDates: any = [];
  checkstoredata: any = [];
  Selectedmemdetails: any = [];
  nextBtn: boolean;
  prevBtn: boolean;
  chkCrnDate: any;
  crnDate: any;
  crnYear: any;
  crnMonth: any;
  wkend: Date;
  diffDays: number;
  repeatmode: boolean;
  daysindex: any = 0;
  datesindex: any = 0;
  daysentry: any;
  [x: string]: any;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  presentView: string;
  presentView1: string;
  showOffers: boolean;
  showOffInfo: boolean;
  clubTimings: boolean;
  selectDate: boolean;
  bookings: boolean;
  canBookings: boolean;
  viewBookingInfo: boolean;
  number: any;
  thanksPopUp: boolean;
  headerValue: string;
  backValue: string;
  showRefundPopUp: boolean;
  playVid: any;
  slctdMemVal: any;
  members: any[];
  maxVisibleMembers = 5;
  storeBackVlu: any;
  dateInfo: any;
  date: string;
  year: string;
  month: string;
  day: string;
  curntDate: any;
  trainerWrkhrs: any;
  vidV: any;
  selectedBooking_time: any;
  termsAccepted = false;
  weekDaysFull: any = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  dateRange: {
    from: Date;
    to: Date;
  };
  getBtwDayslist: { totalDays: any; reminingDays: any; completedday: any };
  remaingDates: any;
  compDate: any;
  //--------------api Integration Variabel---------//
  memProImg: any = '';
  dealType: any;
  rating: any;
  isliked: any;
  profileMediaDetails: any = [];
  dealamt: any;
  ProgramName: any;
  selected_program: any;
  dealid: any;
  storeTrgCentrCategory: any;
  searchStatus: boolean = false;
  searchValue: any = '';
  searchValue1: any = '';
  storeTriningCategoryId: any;
  storeParticulerCategoryInfo: any = [];
  storeTrngCenterId: any;
  particularCenterInfo: any;
  storeOfferIndex: any;
  storeOfferInfo: any;
  storeWorkingDayIndex: any = [];
  disabelDay: any = [];
  patientBasicDetails: any;
  storeBookingList: any = [];
  storeBkgHisList: any = [];
  storeBookingId: any;
  particularBookingInfo: any;
  getTempName: any = null;
  calenderMode: string = 'single';
  storeTodate: Date;
  totalBookingAmount: number;
  storeMembers: any;
  EmtyData: string = null;
  skeletonLoad: any = [];
  getSomePrtclrClupDetails: any;
  storeLabIndex: any;
  pageNo: number = 1;
  StoreWayBookingPageFlow: any;
  showVideoOptins: boolean = true;
  fromDate: any;
  toDate: any;
  empty: number;
  getMemName: any;
  getMemGender: any;
  getMemReletion: any;
  getMemHeight: any;
  getMemWeight: any;
  getMemMobileNo: any;
  terms_and_condition_file: any;
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  length: any;
  nextcount2: any;
  consamount: any;
  conspackagenam: any;
  consname: any;
  conslocation: any;
  distance: any;
  conspath: any;
  conssession: any;
  duration: any;
  packageid: any;
  myToDate: any;
  myFromDate: any;
  rescddays: any = [];
  rescddate: any = [];
  currentMemberId: any;
  indexx;
  showcalender;
  headerName;
  getCenterWorkingHr: any;
  reletionList: any;
  displayMonth: any;
  tymVal: any;
  membersId: any = [];
  refEvent: any;
  scrollEvent: any;
  mklike: any;
  trainCentListReq: any;
  trainCentSrchReq: any;
  partTrainDet: any;
  isShow: any;
  revArr: any = [];
  reviewpercenage: any;
  currentDate: any;
  oldBookId: any;
  partTrainBookDetl: any;
  segvalue: any;
  particulartrainingcenter_index: any;
  showbook: boolean;
  slectedday: any = [];
  showsltday: any = [];
  Like: any;
  isConfirmed: boolean;
  Name: any;
  Email: any;
  phoneno: any;
  showformated_date: any;
  showsheduledate: any;
  referenceid: any;
  orderid: any;
  paymentGatewayNameid: any;
  PackageFromAge: number;
  PackageToAge: number;
  packageAllAge: any;
  PrimaryMemberAge: number;
  isInRange: boolean;
  sprtsHeaderName: string;
  fulldayAvl = [];
  rescheduledSelectedDate = [];
  removepopmodaldata = [];
  payType: any;
  gopayment: boolean = false;
  @Input() typeid;
  @Input() showTypeofBooking;
  hrsText: any;
  iscontainhistory: any = '';
  isFetchingTrainingCenterBookingDetails: any = true;
  Addcheckvarible: boolean = true;
  repeatpage: boolean = false;
  isMuteVideo: boolean = false;
  vidId: any;
  mybackschedule: boolean = false;
  storedPath: null;
  videoLoaded: boolean = false;
  isButtonDisabled: boolean = false;
  isPayButtonDisabled: boolean = false;
  defaultImage = 'assets/img/Vector.png';
  isReviewsVisible: boolean = true;
  ReviewArraybox: any = [];
  BookedValSuccess: boolean = false;
  BookingdatesValidationDetails: [];
  StoreBookedMem: any = [];
  BookedmemberMsg: string;
  lattitude: any;
  longititude: any;
  Sports_lat_lon: any;
  Vendor_Name: any;
  PatientProfileImage: any;
  CameraFileUpload: boolean;
  allowedAgeMembr: boolean = false;
  membernamedetails: any;
  amountpermember: any;
  align: any;
  showsltdates: any = [];
  storetcid: any;
  showformatsltdate: any;
  bookingsCompleted :any;
  bookingsRemaining :any;
  constructor(
    public router: Router,
    private services: ServicesProvider,
    private datePipe: DatePipe,
    public alertCtrl: AlertController,
    public toastController: ToastController,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public fileupload: FileUploadService,
    public addCall: AddCall,
    public popoverCtrl: PopoverController,
    private payment: Payment,
    public common: CommonService,
    private geolocation: Geolocation,
    private httpClient: HttpClient,
    private file: File,
    private fileOpener: FileOpener
  ) {
    this.isAdvrOpened = false;
  }

  ngOnInit() {
    this.isReviewsVisible = true;
    for (let i = 1; i <= 5; i++) {
      this.skeletonLoad.push(i);
    }

    this.iscontainhistory = window.location.href;
    let date = new Date();
    let day = date.toLocaleString('en-us', { weekday: 'long' });
    this.curntDate = new Date();
    this.curntDate = String(this.curntDate).split(' ');
    this.year = this.curntDate[3];
    this.month = this.curntDate[1];
    this.day = day;
  }

  option = {
    percent: 75,
    maxPercent: 100,
    startFromZero: false,
    radius: 20,
    outerStrokeWidth: 3,
    outerStrokeColor: 'var(--app-theme)',
    animation: true,
    animationDuration: 500,
    showInnerStroke: false,
    space: -13,
    backgroundStrokeWidth: 3,
    backgroundStroke: '#e8e8e8',
    backgroundPadding: -2,
    showSubtitle: false,
    showUnits: false,
    showTitle: false,
  };
  option1 = {
    percent: 75,
    maxPercent: 100,
    startFromZero: false,
    radius: 20,
    outerStrokeWidth: 3,
    outerStrokeColor: 'var(--app-theme)',
    animation: true,
    animationDuration: 500,
    showInnerStroke: false,
    space: -13,
    backgroundStrokeWidth: 3,
    backgroundStroke: '#e8e8e8',
    backgroundPadding: -2,
    showSubtitle: false,
    showUnits: false,
    showTitle: false,
    clockwise: false,
  };

  //------------\/--------Calender Type Script Only--------------\/------//

  dateRange1: any;
  clearSelectedDates() {
    this.slectedday = [];
    this.dateRange = null;
    this.dateRange1 = null;
    this.fromDate = '';
    this.toDate = '';
    this.showformated_date = '';
    this.showsltday = '';
  }
  todayDateDisable() {
    let el = document.querySelector('.days .today') as
      | HTMLButtonElement
      | HTMLInputElement
      | null;
    if (el) {
      el.disabled = true;
      el.classList.remove('today');
    }
  }

  onChange($event: any) {
    debugger;
    let val = this.extractValue($event);
    this.setCalendarMode();
    this.resetSelections();

    if (this.calenderMode === 'single') {
      this.handleSingleMode(val);
    } else {
      this.handleMultiMode();
    }
  }

  extractValue(event: any): any {
    debugger;
    return event.length > 0 ? event[event.length - 1] : event;
  }

  setCalendarMode() {
    debugger;
    this.calenderMode = this.conssession < 1 ? 'multi' : 'single';
  }

  resetSelections() {
    debugger;
    this.slectedday = [];
    this.scroll();
  }

  handleSingleMode(val: any) {
    debugger;
    this.calenderMode = 'multi';
    this.dateInfo = val;
    const item = this.dateInfo[0] ? this.dateInfo[0]._d : this.dateInfo._d;

    this.setDateAttributes(item);
    this.autoSetToDate(this.conssession, item);
    this.setCalendarOptions();
    this.checkBookingAvailability(item);

    let storeFromDate = new Date(
      item?.getFullYear(),
      item?.getMonth(),
      item?.getDate()
    );
    let storeToDates = new Date(
      this.storeTodate?.getFullYear(),
      this.storeTodate?.getMonth(),
      this.storeTodate?.getDate()
    );
    this.handleMonthDifference(storeFromDate, storeToDates);
    this.generateFormattedDates(storeFromDate, storeToDates);
  }

  setDateAttributes(item: any) {
    debugger;
    let dateArray = String(item).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.day = item.toLocaleString('en-us', { weekday: 'long' });
  }

  setCalendarOptions() {
    debugger;
    this.optionsMulti = {
      pickMode: this.calenderMode,
      weekdays: [
        this.addCall.title411,
        this.addCall.title412,
        this.addCall.title413,
        this.addCall.title414,
        this.addCall.title415,
        this.addCall.title416,
        this.addCall.title417,
      ],
      disableWeeks: this.disabelDay,
    };
  }

  checkBookingAvailability(item: any) {
    debugger;
    let packfrom_date = new Date(this.package_startdate).toString();
    let packto_date = new Date(this.package_todate).toString();
    let slected_todate = new Date(this.storeTodate).toString();

    if (this.package_startdate != null) {
      if (
        new Date(packfrom_date) >= new Date(item) &&
        new Date(packto_date) >= new Date(slected_todate)
      ) {
        this.showbook = true;
      } else {
        this.showbook = false;
        this.presentToast(
          'This is Limited Duration Bookings,So check your booking dates.'
        );
      }
    } else {
      this.showbook = true;
    }
  }

  handleMonthDifference(storeFromDate: Date, storeToDates: Date) {
    debugger;
    let monthdiff = this.getMonthDifference(storeFromDate, storeToDates);

    for (let i = 1; i <= monthdiff; i++) {
      setTimeout(() => {
        $('.forward').trigger('click');
      }, 1000);
    }
  }

  getMonthDifference(startDate: Date, endDate: Date): number {
    debugger;
    return (
      endDate.getMonth() -
      startDate.getMonth() +
      12 * (endDate.getFullYear() - startDate.getFullYear())
    );
  }

  generateFormattedDates(storeFromDate: Date, storeToDates: Date) {
    debugger;
    let storedateformat = [];
    this.showformated_date =
      new Date(storeFromDate).toString().split(' ')[0] +
      ', ' +
      new Date(storeFromDate).toString().split(' ')[1] +
      ' ' +
      new Date(storeFromDate).toString().split(' ')[2];

    for (
      let storedate = new Date(storeFromDate);
      storedate <= new Date(storeToDates);
      storedate.setDate(storedate.getDate() + 1)
    ) {
      let str = new Date(storedate).toLocaleString('default', {
        weekday: 'short',
      });

      if (this.dayinweek.includes(str)) {
        storedateformat.push(this.getFormattedDateTime(storedate, 'datefor'));
        this.slectedday.push(this.getFormattedDateTime(storedate, 'Date1'));
        if (this.slectedday.length === 1) {
          this.showsltday = this.slectedday[0];
        } else if (this.slectedday.length > 1) {
          this.showsltday = this.slectedday.slice(0, 2).join(', ');
        }
      }
    }
    this.dateRange1 = storedateformat;

    this.dateRange = {
      from: new Date(
        storeFromDate.getFullYear(),
        storeFromDate.getMonth(),
        storeFromDate.getDate()
      ),
      to: new Date(
        storeToDates.getFullYear(),
        storeToDates.getMonth(),
        storeToDates.getDate()
      ),
    };
    setTimeout(() => {
      this.todayDateDisable();
    }, 500);
    let getDate = this.dateRange.from;
    this.fromDate =
      getDate.getFullYear() +
      '-' +
      ('0' + (getDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + getDate.getDate()).slice(-2);
    let getDate1 = this.dateRange.to;
    this.toDate =
      getDate1.getFullYear() +
      '-' +
      ('0' + (getDate1.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + getDate1.getDate()).slice(-2);
  }

  handleMultiMode() {
    debugger;
    this.calenderMode = 'single';
    this.setCalendarOptions();
    this.dateRange = null;
    this.dateRange1 = null;
  }

  autoSetToDate(days, frmdate) {
    debugger;
    let date = new Date(frmdate);
    this.storeTodate = null;
    let fillDate = [new Date(date)];

    let i = 1;
    while (i <= 1000) {
      date.setDate(date.getDate() + 1);
      if (fillDate.length == days) {
        this.storeTodate = fillDate[fillDate.length - 1]
          ? fillDate[fillDate.length - 1]
          : fillDate[0];
        break;
      }
      if (!this.disabelDay.includes(date.getDay())) {
        fillDate.push(new Date(date));
      }

      i++;
    }
  }

  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultImage;
  }

  handleError(event: any, gender: string): void {
    if (gender?.toLowerCase() === 'male') {
      event.target.src = 'assets/newIcons/MaleJpg.jpg';
    } else if (gender?.toLowerCase() === 'female') {
      event.target.src = 'assets/newIcons/FeMaleJpg.jpg';
    }
  }

  dateMulti: string[];
  type: 'string';
  optionsMulti: CalendarModalOptions;

  //-------------/\--------Calender Type Script Only------------/\---------------//

  //---------------------><-----------------------><-------------------------><--------------------><---------------------------//

  // ------------\/--------PRE DEFINE FUNCTION'S-----------\/-------//

  doRefresh(event: any, page: any) {
    this.refEvent = event;
    this.pageNo = 1;
    this.searchValue = '';
    setTimeout(() => {
      if (page == 'listPage') {
        this.storeParticulerCategoryInfo = [];
        this.openClups(this.storeTriningCategoryId);
      } else if (page == 'bookingsOrHis') {
        this.EmtyData = null;
        this.wayOfBookingListpages(this.StoreWayBookingPageFlow);
      }
    }, 800);
  }

  dayvalvheck() {
    let vall = [];
    this.selectedBooking_time = [];
    for (let item of this.fulldayAvl) {
      let ans = this.trainerWrkhrs.filter((tr) => item == tr.wh_weekday);
      this.selectedBooking_time.push(...ans); // Add filtered results to vall array
    }
    // Do something with the collected filtered results in vall array
    // For example, you can return vall or perform other operations
    // return vall;
  }
  formatMoney(number: any) {
    const num = Number(number);
    const options = {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    };

    const formattedNumber = num.toLocaleString('en-US', options);
    const parts = formattedNumber.split('.');

    if (parts.length === 1) {
      return `${formattedNumber}.000`;
    } else {
      const decimalPart = parts[1].padEnd(3, '0');
      return `${parts[0]}.${decimalPart}`;
    }
  }

  loadData(event: any, page: any) {
    this.scrollEvent = event;
    this.pageNo += 1;
    if (this.nextcount2 == 0) {
      event.target.disabled = true;
    } else if (page == 'listTrainingCenter') {
      this.openClups(this.storeTriningCategoryId);
    } else if (this.StoreWayBookingPageFlow == 'bookingList') {
      this.bookingList();
    } else if (this.StoreWayBookingPageFlow == 'bookingHisList') {
      this.bookingHis();
    }
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }
  async openDatePicker2() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        selectedDate: this.selectedDate,
        calenderType: 'dob', //normal/dob
      },
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss().then((data) => {
      if (data.data) {
        let getDate = data.data;
        this.membDOB = this.getFormattedDateTime(getDate, 'Date1');
        this.getMemDob =
          getDate.getFullYear() +
          '-' +
          ('0' + (getDate.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + getDate.getDate()).slice(-2);
      }
    });
  }

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    await alert.present();
  }
  async BookingAlertInfo(status) {
    const alert = await this.modalCtrl.create({
      component: BookingdatemodalPage,
      cssClass: 'Book_alert',
      backdropDismiss: false,
      componentProps: {
        msg: this.BookedmemberMsg,
        sts: status,
        BookedMemberD: this.StoreBookedMem,
      },
    });
    await alert.present();
  }

  // ------------/\--------PRE DEFINE FUNCTION'S-----------/\-------//

  //--------------------><--------------><-------------------------><-------------------------><---------------------------------------//

  //------\/---------Some Special Funtion's------\/-------//

  onIntersection($event: any, id: any, index: any, Sindex: any) {
    const {
      [InViewportMetadata]: { entry },
      target,
    } = $event;
    const ratio = entry.intersectionRatio;
    const vid = target;

    if (ratio >= 0.75) {
      vid.play();
      this.checkVideo(id, index, Sindex);
      this.getDietCompanyList[index].mediaDetails[Sindex].playMode = true;
    } else {
      if (
        this.storeParticulerCategoryInfo[index].mediaDetails[Sindex].playMode
      ) {
        vid.pause();
        this.storeParticulerCategoryInfo[index].mediaDetails[Sindex].playMode =
          false;
      }
    }
  }

  checkVideo(id, index, Sindex) {
    const video = document.getElementById(id);
    const d = this;
    video.onended = function () {
      d.storeParticulerCategoryInfo[index].mediaDetails[Sindex].playMode =
        false;
    };
  }

  playVideo(index, Sindex, id, value) {
    this.showPlyOptn();
    this.playVid = document.getElementById(id);
    switch (value) {
      case 'play': {
        this.playVid.play();
        this.storeParticulerCategoryInfo[index].mediaDetails[Sindex].playMode =
          true;
        break;
      }
      case 'pause': {
        this.playVid.pause();
        this.storeParticulerCategoryInfo[index].mediaDetails[Sindex].playMode =
          false;
        break;
      }
    }
  }

  showPlyOptn() {
    this.showVideoOptins = true;
    setTimeout(() => {
      this.showVideoOptins = false;
    }, 5000);
  }

  selectMember(value: any, memId: any, age: any, mprofile: any) {
    debugger;

    this.slctdMemVal = value;
    this.currentMemberId = memId;
    if (!this.membersId.includes(this.currentMemberId)) {
      this.membersId.push(this.currentMemberId);
      if (!this.members.includes(this.currentMemberId)) {
        this.members.push(this.slctdMemVal);
        this.checkstoredata.push({
          id: this.membersId,
          name: this.slctdMemVal,
        });
        this.Selectedmemdetails.push({
          id: memId,
          name: value,
          profile: mprofile,
        });
        this.totalBookingAmount =
          Number(this.members.length) * Number(this.consamount);
      }
    }
    if (!this.dealValue) {
      this.dealValue = 0;
    }
    if (this.dealOption == 'Amount') {
      this.dealType = 'KWD';
      this.finalPay = Number(this.totalBookingAmount) - Number(this.dealValue);
    } else if (this.dealOption == 'Percentage') {
      this.dealType = '%';
      this.finalPay =
        Number(this.totalBookingAmount) -
        (Number(this.totalBookingAmount) * Number(this.dealValue)) / 100;
    } else {
      this.finalPay = this.totalBookingAmount;
    }
  }

  removeSelectMem(value) {
    this.members.splice(value, 1);
    this.membersId.splice(value, 1);
    this.Selectedmemdetails.splice(value, 1);

    this.totalBookingAmount =
      Number(this.members.length) * Number(this.consamount);
    if (this.members.length == 0) {
      this.totalBookingAmount = this.consamount;
    }
    if (!this.dealValue) {
      this.dealValue = 0;
    }

    if (this.dealOption == 'Amount') {
      this.dealType = 'KWD';
      this.finalPay = Number(this.totalBookingAmount) - Number(this.dealValue);
    } else if (this.dealOption == 'Percentage') {
      this.dealType = '%';
      this.finalPay =
        Number(this.totalBookingAmount) -
        (Number(this.totalBookingAmount) * Number(this.dealValue)) / 100;
    } else {
      this.finalPay = this.totalBookingAmount;
    }
  }

  //------/\---------Some Special Funtion's------/\-------//

  async ionViewWillEnter() {
    let options = {
      enableHighAccuracy: true,
      timeout: 5000,
    };
    await this.geolocation.getCurrentPosition(options).then(
      (resp) => {
        this.LocationIcon = true;
        this.lattitude = resp.coords.latitude;
        this.longititude = resp.coords.longitude;
      },
      (err) => {
        this.LocationIcon = false;
        this.lattitude = 29.62107798734671;
        this.longititude = 47.587719496877924;
        console.log('Error getting location', err);
      }
    );
    this.presentView = 'selectCatagory';
    this.sprtsHeaderName = this.addCall.title560;
    this.commonheadervalue = 'trainerheader';
    this.common.videoSound = true;
    this.showcoment = false;
    this.showformated_date =
      new Date().toString().split(' ')[0] +
      ', ' +
      new Date().toString().split(' ')[1] +
      ' ' +
      new Date().toString().split(' ')[2];
    this.programdetails = [];
    this.ratingBasedSortingOrder = 'ASC';
    this.ratingSorting = false;
    this.reschdulefrom = [];
    this.reschduleto = [];
    this.pageNo = 1;
    this.searchValue = '';
    this.searchValue1 = '';
    this.likestatus = 0;
    this.isliked = 0;
    this.ProgramName = null;
    this.selected_program = null;
    this.dateArr = [];
    this.segvalue = 'outdoor';
    this.segtypeval = 2;
    this.currentDate = new Date().toISOString().split('T')[0];
    // this.getPatientBasicDetails();
    this.storeParticulerCategoryInfo = [];
    this.PatientProfileImage = '';
    switch (localStorage.getItem('NopayGoBack')) {
      case 'newEnter': {
        this.showCatPage();
        break;
      }
      case 'BookingConPage': {
        this.bookingConfirm(0);
        break;
      }
      default: {
        this.showCatPage();
      }
    }
  }

  showCatPage() {
    this.isShowHeaderValue = true;
    this.commonheadervalue = 'trainerheader';
    this.storeTrgCentrCategory = [];
    if (this.trainCentListReq) {
      this.trainCentListReq.unsubscribe();
    }
    this.presentView = 'selectCatagory';
    this.thanksPopUp = false;
    this.bookings = false;
    this.backValue = 'step0';
    this.headerValue = this.addCall.title560;

    this.length = null;

    let apiData = JSON.stringify({
      typesearch: this.segtypeval,
      searchContent: this.searchValue,
    });
    this.trainCentListReq = this.services
      .postRequest2('getTrainingListForTrainingCenter', apiData)
      .subscribe((res) => {
        if (res.status == 1) {
          this.length = res.status;
          this.storeTrgCentrCategory = res.data;
        } else {
          this.storeTrgCentrCategory = [];
          this.length = res.status;
        }
      });
    this.searchStatus = false;
  }
  searchCat() {
    this.searchStatus = true;
    this.showCatPage();
  }

  Videobruff(el) {
    return true;
  }

  ionViewDidLeave() {
    this.isConfirmed = false;
    this.isAdvrOpened = false;
    const inViewPort = this.vdoPlayer.find((player) =>
      this.Videobruff(player.nativeElement)
    );
    if (inViewPort) {
      inViewPort.nativeElement.pause();
    }
    this.didScrollEvent('leave');
    this.isMuteVideo = false;
    this.common.videoSound = false;
    if (this.currentPlaying) {
      this.currentPlaying.muted = true;
      this.currentPlaying?.pause();
      this.currentPlaying = null;
    }
    setTimeout(() => {
      this.didScrollEvent('leave');
      this.isMuteVideo = false;
      this.common.videoSound = false;
      if (this.currentPlaying) {
        this.currentPlaying.muted = true;
        this.currentPlaying?.pause();
        this.currentPlaying = null;
      }
    }, 500);
  }

  getdetail: any;
  openClups(categoryId) {
    this.getAdd();
    this.searchValue = '';
    if (this.trainCentSrchReq) {
      this.trainCentSrchReq.unsubscribe();
    }
    this.nextcount2 = 0;
    if (this.pageNo == 1) {
      this.storeParticulerCategoryInfo = [];
      this.empty = null;
    }
    if (!this.searchValue) {
      this.searchValue = '';
    }
    this.storeTriningCategoryId = categoryId;
    this.presentView = 'listClubPage';
    this.backValue = 'step1';
    this.headerValue = 'Clubs';
    let apiData = JSON.stringify({
      trainingId: categoryId,
      currentDate: new Date().toISOString().split('T')[0],
      pageno: this.pageNo,
      limit: 100,
      typesearch: this.searchStatus,
      searchContent: this.searchValue1,
      patientId: localStorage.getItem('patient_id'),
      ratingBasedSorting: this.ratingSorting,
      ratingBasedSortingOrder: this.ratingBasedSortingOrder,
      latitude: this.lattitude,
      longtitude: this.longititude,
    });
    this.trainCentSrchReq = this.services
      .postRequest('patientTrainingCenterSearch', apiData)
      .subscribe((res) => {
        this.getdetail = res.status;
        if (this.common.videoSound) {
          const interval = setInterval(() => {
            this.currentPlaying = null;
            if (this.vdoPlayer) {
              clearInterval(interval);
            }
          }, 0);
        }
        res.status == 1
          ? (this.nextcount2 = res.data[0].nextCount)
          : (this.nextcount2 = 0);
        if (this.refEvent) {
          this.refEvent.target.complete();
        }
        if (this.scrollEvent) {
          this.scrollEvent.target.complete();
        }

        if (this.pageNo == 1) {
          this.empty = res.status;
          this.storeParticulerCategoryInfo = [];
        }
        if (res.status == 1) {
          this.empty = 1;
          for (let item of res.data[0].details) {
            for (let item2 of item.mediaDetails) {
              item2['playMode'] = false;
            }
            this.storeParticulerCategoryInfo.push(item);
          }
        }
        this.searchStatus = false;
      });
  }

  searchClups() {
    this.searchStatus = true;
    this.openClups(this.storeTriningCategoryId);
  }
  workinghrs: any;
  likestatus: any;
  Experience: any;
  dayinweek: any = [];
  programdetails: any = [];
  dealprogram: any;
  sdhowpro: any;

  selectProfile(centerId: any, index: any, header: any, item: any) {
    this.currentPlaying?.pause();
    this.isShow = !this.isShow;
    this.showcoment = false;
    this.presentView = 'clubProfileInfo';
    this.isShowHeaderValue = true;
    this.commonheadervalue = 'listTrainerPage';
    this.sdhowpro = 0;
    this.showbook = false;
    this.selected_program = null;
    this.getMedia(centerId);
    this.particulartrainingcenter_index = index;
    this.partTrainDet = item;
    this.rating = item.review.toFixed(1);
    this.headerValue = header;
    this.empty = null;
    this.storeTrngCenterId = centerId;
    this.storeLabIndex = index;
    this.searchValue = '';
    this.searchValue1 = '';
    this.particularCenterInfo = null;
    this.reviewpercenage =
      this.storeParticulerCategoryInfo[index].review_percentage.toFixed();
    this.isShow = true;
    this.showOffers = true;
    this.showOffInfo = false;
    this.backValue = 'step2';
    this.getSomePrtclrClupDetails = this.storeParticulerCategoryInfo[index];
    this.conspath = this.getSomePrtclrClupDetails.vendor_profile_path;
    this.consname = this.getSomePrtclrClupDetails.vendor_name;
    this.conslocation = this.getSomePrtclrClupDetails.vendor_location;
    this.Like = this.getSomePrtclrClupDetails.likes_count;
    this.likestatus = this.getSomePrtclrClupDetails.isLiked;
    this.storeBackVlu = null;
    this.getparticulartrainer_cerntrdet('', '');
  }

  revArr1: any = [];
  getparticulartrainer_cerntrdet(value, packageid) {
    debugger;
    let reviewArray = [];
    this.revArr1 = [];
    this.ReviewArraybox = [];
    let apiData = JSON.stringify({
      trainingCenterId: this.storeTrngCenterId,
      trainingId: this.storeTriningCategoryId,
      currentDate:
        new Date().getFullYear() +
        '-' +
        (new Date().getUTCMonth() + 1) +
        '-' +
        new Date().getDate(),
      patientId: localStorage.getItem('patient_id'),
      lattitude: this.lattitude,
      longititude: this.longititude,
    });
    this.services
      .postRequest('getParticularTrainingCenterDetails', apiData)
      .subscribe(async (res) => {
        this.sdhowpro = res.status;
        let hrsmintxt = res.data[0].programList[0].duration.slice(0, 2);
        if (hrsmintxt == '00') {
          this.hrsText = 'min';
        } else {
          this.hrsText = 'hrs';
        }
        this.particularCenterInfo = res.data[0];
        this.trainerWrkhrs = res.data[0].trainingCenterWorkinghours;
        this.distance = res.data[0].Distance;
        this.Vendor_Name = res.data[0].trainerName;
        this.Sports_lat_lon = res.data[0].vendor_latlong;

        this.isliked = this.particularCenterInfo.isLiked;
        this.getCenterWorkingHr =
          this.particularCenterInfo.trainingCenterWorkinghours;
        this.Experience =
          new Date().getFullYear() -
          new Date(this.particularCenterInfo.vendor_since).getFullYear();
        if (this.particularCenterInfo.review_comment) {
          reviewArray = JSON.parse(this.particularCenterInfo.review_comment);
          this.ReviewArraybox = [...reviewArray];
          this.revArr1 = [reviewArray[0]];
        }

        if (res.data[0].programList.length == 0) {
          this.empty = 1;
        } else {
          this.empty = 0;
        }
        this.conscenterid = this.particularCenterInfo.trainingCenterId;
        this.partTrainDet = this.particularCenterInfo;

        if (this.dealserviceid) {
          this.programdetails = this.particularCenterInfo.programList;
          this.dealprogram = this.programdetails.find(
            (deal) => deal.dealService === this.dealserviceid
          );
          this.chooseprogramdetails(this.dealprogram);
        }

        const array = [];

        for (let item of this.particularCenterInfo.trainingCenterWorkinghours) {
          array.push({
            timing: item.wh_fromtime + '-' + item.wh_totime,
            wh_weekday: item.wh_weekday,
            wh_fromtime: item.wh_fromtime,
            wh_totime: item.wh_totime,
          });
        }
        const groupedMap = array.reduce(
          (entryMap, e) =>
            entryMap.set(e.timing, [
              ...(entryMap.get(e.timing) || []),
              e.wh_weekday.substr(0, 3),
            ]),
          new Map()
        );

        this.workinghrs = Array.from(groupedMap);

        this.storeBackVlu = value;
        if (this.storeBackVlu == 'Repeat') {
          this.particularCenterInfo.programList.filter((item) => {
            if (item.packageId == packageid) {
              this.chooseprogramdetails(item);
            }
          });
          this.backValue = 'step1-2';
        }
      });
  }

  getMedia(tr_id) {
    let tempArr = [];
    if (this.mediaReq) {
      this.mediaReq.unsubscribe();
    }
    this.profileMediaDetails = [];
    let apiData2 = JSON.stringify({
      doctorId: tr_id,
      limit: 1000,
      pageno: 1,
    });
    this.mediaReq = this.services
      .postRequest('getMediaDetailsByDoctor', apiData2)
      .subscribe((res) => {
        for (let item of res.data[0].details) {
          tempArr.push(item);
          if (tempArr.length == 3) {
            this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
            tempArr = [];
          }
        }
        if (tempArr.length > 0) {
          this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
        }
      });
  }

  getBookedDatevalidation(callback: Function) {
    debugger;
    let Send_Payload = JSON.stringify({
      trainingCenterId: this.particularCenterInfo.trainingCenterId,
      patientId: localStorage.getItem('patient_id'),
      selectedFromdate: this.fromDate,
      selectedTodate: this.toDate,
      packageID: this.packageid
        ? this.packageid
        : this.particularCenterInfo.programList[0].packageId,
      membersInvolved: this.membersId.toString(),
      tempMemberName: this.members,
      membersDetails: this.Selectedmemdetails,
      Selected_dates: this.dateRange1,
    });

    this.mediaReq = this.services
      .postRequestGndrl('Sports/BookingdatesValidation', Send_Payload)
      .subscribe((res) => {
        const responseData = res;
        this.StoreBookedMem = [];
        if (responseData.msg === 'These members are already booked.') {
          this.BookedmemberMsg =
            this.addCall.selectedLanguage === 'en'
              ? responseData.msg
              : 'تم حجز هذه الأعضاء بالفعل.';
        } else if (
          responseData.msg ===
          'These members are available to book these dates.'
        ) {
          this.BookedmemberMsg =
            this.addCall.selectedLanguage === 'en'
              ? responseData.msg
              : 'هؤلاء الأعضاء متاحون لحجز هذه التواريخ.';
        }

        if (responseData.errorcode !== 9999) {
          this.BookedValSuccess = false;
          if (responseData.data && responseData.data.length > 0) {
            this.StoreBookedMem = responseData.data;
          }
        } else {
          this.StoreBookedMem = [];
          this.BookedValSuccess = true;
        }
        callback();
      });
  }

  clupWorkingHr() {
    const strWeekDaysIndex = [];
    this.storeWorkingDayIndex = [];
    this.disabelDay = [];
    for (let item of this.weekDaysFull) {
      let getIndex = this.weekDaysFull.indexOf(item);

      strWeekDaysIndex.push(getIndex);
    }
    if (this.dayBwhorking.lentgh < 0) {
      this.dayBwhorking = [''];
    }
    this.dayBwhorking.forEach((data) => {
      this.storeWorkingDayIndex.push(Number(data) - 1);
    });
    for (let item of strWeekDaysIndex) {
      if (!this.storeWorkingDayIndex.includes(item)) {
        this.disabelDay.push(item);
      }
    }
    this.optionsMulti = {
      pickMode: this.calenderMode,
      weekdays: [
        this.addCall.title411,
        this.addCall.title412,
        this.addCall.title413,
        this.addCall.title414,
        this.addCall.title415,
        this.addCall.title416,
        this.addCall.title417,
      ],
      disableWeeks: this.disabelDay,
    };
  }

  dealOption: any;
  dealValue: any;
  dealvalue1: any;
  openOffInfo(index: any) {
    this.storeOfferInfo = this.particularCenterInfo.programList[index];
    this.dealValue = this.particularCenterInfo.programList[index].dealValue;
    this.dealValue1 = this.particularCenterInfo.programList[index].dealValue;
    this.consamount = this.storeOfferInfo.trcr_cost;
    this.conspackagenam = this.storeOfferInfo.trcr_package_name;
    var hrsmintxt = this.storeOfferInfo.duration.slice(0, 2);
    if (hrsmintxt == '00') {
      this.hrsText = 'min';
    } else {
      this.hrsText = 'hrs';
    }
    this.duration = this.storeOfferInfo.duration;
    this.dealoroff = this.storeOfferInfo.dealValue;
    this.packageid = this.storeOfferInfo.packageId;
    this.storeOfferIndex = index;
    this.backValue = 'step3';
    this.headerValue = this.consname;
  }
  selectProgramDate(value) {
    this.members = [];
    this.Selectedmemdetails = [];
    this.membersId = [];
    this.dateRange = null;
    this.dateRange1 = null;
    this.presentView = 'clubProfileInfo';
    this.presentView1 = 'clubProfileInfo1';
    this.clubTimings = false;
    this.showOffers = false;
    this.showOffInfo = true;
    this.selectDate = true;
    this.backValue = 'step4';
    if (this.calenderMode == 'single') {
      this.calenderMode = 'multi';
      this.optionsMulti = {
        pickMode: this.calenderMode,
        weekdays: [
          this.addCall.title411,
          this.addCall.title412,
          this.addCall.title413,
          this.addCall.title414,
          this.addCall.title415,
          this.addCall.title416,
          this.addCall.title417,
        ],
        disableWeeks: this.disabelDay,
      };
    }

    this.headerValue = this.consname;
    this.storeBackVlu = value;
    if (this.storeBackVlu == 'Repeat') {
      this.backValue = 'step1-2';
    }
  }

  bookpageval: any;

  bookingConfirm(bookpage: any) {
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      trainingCenterId: this.conscenterid,
      packageId: this.packageid,
      fromDate: this.fromDate,
      toDate: this.toDate,
      bookedDate:
        new Date().toISOString().split('T')[0] +
        ' ' +
        new Date().toLocaleTimeString('en-US', { hour12: false }),
      amount: this.finalPay,
      paymentStatus: '1',
      isMember: 2,
      tempMemberName: this.members,
      dealid: this.dealid,
      dealoption: this.dealOption,
      dealvalue: this.dealValue1,
      paymentid: this.paymentid,
      referenceid: this.referenceid,
      order_id: this.orderid,
      paymentGatewayName: this.paymentGatewayNameid,
      membersInvolved: this.membersId.toString(),
      Selected_dates: this.dateRange1,
      Selected_time: JSON.stringify(this.selectedBooking_time),
      trainingcenter_categoryid: this.storeTriningCategoryId,
    });

    debugger;
    this.getBookedDatevalidation(() => {
      if (!this.BookedValSuccess) {
        this.BookingAlertInfo('This Member already booked');
        return; // Exit the function if validation failed
      }

      this.showcoment = false;
      this.totalBookingAmount =
        Number(this.members.length) * Number(this.consamount);
      if (this.members.length == 0) {
        this.totalBookingAmount = this.consamount;
      }
      if (!this.dealValue) {
        this.dealValue = 0;
      }
      if (this.dealOption == 'Amount') {
        this.dealType = 'KWD';
        this.finalPay =
          Number(this.totalBookingAmount) - Number(this.dealValue);
      } else if (this.dealOption == 'Percentage') {
        this.dealType = '%';
        this.finalPay =
          Number(this.totalBookingAmount) -
          (Number(this.totalBookingAmount) * Number(this.dealValue)) / 100;
      } else {
        this.finalPay = this.totalBookingAmount;
      }
      this.bookpageval = bookpage;
      if (
        this.optionsMulti.pickMode == 'multi' &&
        this.fromDate != null &&
        this.toDate != null
      ) {
        this.presentView =
          this.presentView == 'clubProfileInforepeat'
            ? 'confoirmBookingreapt'
            : 'confoirmBooking';
        if (bookpage == 1 && this.storeBackVlu != 'Repeat') {
          this.backValue = 'step5';
        } else if (this.storeBackVlu == 'Repeat') {
          this.backValue = 'step1-5';
        }
        this.headerValue = this.addCall.title40;
        if (!this.iscontainhistory.includes('trainingCenter')) {
          this.getPatientBasicDetails();
        }
      } else {
        this.presentToast('Please Select Date');
      }
    });
  }


  getPatientBasicDetails() {
    debugger;

    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      currentDate: new Date().toISOString().split('T')[0],
      currentTime: new Date().toTimeString().split(' ')[0],
    });
    this.services.postRequest('getPatientProfile', apiData).subscribe((res) => {
      this.patientBasicDetails = res.data[0];

      this.Name = this.patientBasicDetails.name;
      this.Email = this.patientBasicDetails.email;
      this.phoneno = this.patientBasicDetails.phone_no;
      this.Address = this.patientBasicDetails.address;

      // Package Age Range
      this.PackageFromAge = this.selected_programdetails?.trcr_age_from !== "" ? Number(this.selected_programdetails?.trcr_age_from) : null;
      this.PackageToAge = this.selected_programdetails?.trcr_age_to !== "" ? Number(this.selected_programdetails?.trcr_age_to) : null;

      let MainMemberDetails = [
        {
          type: "MainMember",
          PatientMemberId: this.patientBasicDetails.patientId,
          patientMemberImage: this.patientBasicDetails.profile_image,
          dob: this.patientBasicDetails.dob,
          age: this.patientBasicDetails.age + ' yrs',
          name: this.patientBasicDetails.name,
          patient_id: this.patientBasicDetails.patientId,
        },
      ];


      this.storeMembers = [...MainMemberDetails, ...this.patientBasicDetails.patientmemberDetails];
      console.log(this.storeMembers, "111");
      this.filteredMembers = [];
      this.filteredMembers = this.storeMembers.filter((member) => {
        if (!member.age) return false; // Skip if age is undefined
        let ageInYears = 0;
        if (typeof member.age === 'string') {
          if (member.age.includes('yrs')) {
            ageInYears = parseInt(member.age); // Extract years
          } else if (member.age.includes('weeks')) {
            let weeks = parseInt(member.age); // Extract weeks
            ageInYears = weeks / 52; // Convert weeks to years
          } else {
            return false; // Skip if the age format is unrecognized
          }
        } else {
          return false;
        }
        if (this.PackageFromAge === null && this.PackageToAge === null) {
          return true; // Show all members
        }
        const isFromAgeValid = this.PackageFromAge || this.PackageFromAge === 0; // Allow 0 as a valid age
        const isToAgeValid = this.PackageToAge || this.PackageToAge === 0; // Allow 0 as a valid age
        return (
          (!isFromAgeValid || ageInYears >= this.PackageFromAge) &&
          (!isToAgeValid || ageInYears <= this.PackageToAge)
        );
      });

      console.log(this.filteredMembers, "111");

      if (this.filteredMembers.length > 0) {
        this.members = [this.filteredMembers[0].name];
        this.membersId = [this.filteredMembers[0].PatientMemberId];
        this.Selectedmemdetails = [
          {
            id: this.filteredMembers[0].PatientMemberId,
            name: this.filteredMembers[0].name,
            profile: this.filteredMembers[0].profile_image,
          },
        ];
        this.currentMemberId = localStorage.getItem('patient_id');
        this.totalBookingAmount = Number(this.members.length) * Number(this.consamount);
      } else {
        this.members = [];
        this.membersId = [];
        this.Selectedmemdetails = [];
        this.currentMemberId = "";
        this.totalBookingAmount = 0;
      }

      // Deal Value Calculation
      if (!this.dealValue) {
        this.dealValue = 0;
      }

      if (this.dealOption === 'Amount') {
        this.dealType = 'KWD';
        this.finalPay =
          Number(this.totalBookingAmount) - Number(this.dealValue);
      } else if (this.dealOption === 'Percentage') {
        this.dealType = '%';
        this.finalPay =
          this.totalBookingAmount -
          (Number(this.totalBookingAmount) * Number(this.dealValue)) / 100;
      } else {
        this.finalPay = this.totalBookingAmount;
      }

      console.log(this.filteredMembers, "111 filter data");
    });
  }

  addMember() {
    debugger;
    this.presentView =
      this.presentView == 'confoirmBookingreapt'
        ? 'addMemberPagereapt'
        : 'addMemberPage';
    this.backValue = 'step6';

    this.headerValue =
      this.addCall.selectedLanguage == 'en' ? 'Add Member' : 'أضف أحد الأفراد';
    this.getMemName = null;
    this.getMemGender = null;
    this.getMemReletion = null;
    this.getMemHeight = null;
    this.getMemWeight = null;
    this.getMemMobileNo = null;
    this.membDOB = null;
    this.getMemDob = null;
    this.getPatientReletion();
  }

  getPatientReletion() {
    this.services.getRequest('getpatientrelation').subscribe((res) => {
      this.reletionList = res.data;
    });
  }

  insertMemberDetails() {
    if (
      this.getMemName != null &&
      this.getMemGender != null &&
      this.getMemReletion != null &&
      this.getMemHeight != null &&
      this.getMemWeight != null &&
      this.getMemDob != null
    ) {
      this.insertMember();
    } else {
      let value = [
        {
          f_Name: 'Enter Name',
          f_value: this.getMemName,
        },
        {
          f_Name: 'Choose Gender',
          f_value: this.getMemGender,
        },
        {
          f_Name: 'Select Date Of Birth',
          f_value: this.getMemDob,
        },
        {
          f_Name: 'Choose Reletion',
          f_value: this.getMemReletion,
        },
        {
          f_Name: 'Enter Height',
          f_value: this.getMemHeight,
        },
        {
          f_Name: 'Enter Weight',
          f_value: this.getMemWeight,
        },
      ];
      for (let item of value) {
        if (item.f_value == null) {
          let Msg = 'Please ' + item.f_Name;
          this.presentToast(Msg);
          break;
        }
      }
    }
  }

  async insertMember() {
    const loading = await this.loadingCtrl.create({
      message: 'Loading.....',
    });
    await loading.present();
    let apiData = JSON.stringify({
      parentpatientId: localStorage.getItem('patient_id'),
      patientId: 0,
      name: this.getMemName,
      gender: this.getMemGender,
      imagearray: this.PatientProfileImage,
      dob: this.getMemDob.split('T')[0],
      relationId: this.getMemReletion,
      heightcm: this.getMemHeight,
      weightkg: this.getMemWeight,
      phoneno: this.getMemMobileNo,
      modifiedby: localStorage.getItem('patient_id'),
    });
    this.services
      .postRequest('addPatientmemberDetails', apiData)
      .subscribe(async (res) => {
        await loading.dismiss();
        if (res.status == 1) {
          setTimeout(() => {
            this.loadingCtrl.dismiss();
          }, 500);
          this.AlertInfo(this.addCall.title280, res.status);
          this.presentView = 'clubProfileInfo';
          this.presentView1 = 'clubProfileInfo1';
          // this.presentView = 'confoirmBooking';
          // this.backValue = 'step5';
          this.headerValue = this.addCall.title40;
          this.getPatientBasicDetails();
        } else {
          setTimeout(() => {
            this.loadingCtrl.dismiss();
          }, 500);
          this.presentToast(res.msg);
        }
      });
  }

  paymentid: any;

  async proceedToPay() {
    if (this.isPayButtonDisabled) {
      return; // If button is already clicked, do nothing
    }
    this.isPayButtonDisabled = true;
    try {
      localStorage.setItem('payBack', 'trainingCenter');
      await this.presentModal1();
    } catch (error) {
      console.error('Error proceeding to pay:', error);
    } finally {
      this.isPayButtonDisabled = false; // Re-enable the button after operation is done
    }
  }
  async insertBooking(response: any) {
    debugger;
    if (this.dealid == null) {
      this.dealid = '';
      this.dealValue1 = '';
      this.dealOption = '';
    }
    if (this.membersId.length == 0) {
      this.presentToast('Atleast one member should be selected!');
    } else {
      let memID: any;
      if (this.membersId.length > 1) {
        memID = this.currentMemberId;
      } else {
        memID = localStorage.getItem('patient_id');
      }
      const loading = await this.loadingCtrl.create({
        message: 'Processing Your Payment Status',
      });
      await loading.present();
      let apiData = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        trainingCenterId: this.particularCenterInfo.trainingCenterId,
        packageId: this.packageid,
        fromDate: this.fromDate,
        toDate: this.toDate,
        bookedDate:
          new Date().toISOString().split('T')[0] +
          ' ' +
          new Date().toLocaleTimeString('en-US', { hour12: false }),
        amount: this.finalPay,
        paymentStatus: '1',
        isMember: 2,
        tempMemberName: this.members,
        dealid: this.dealid,
        dealoption: this.dealOption,
        dealvalue: this.dealValue1,
        paymentid: this.paymentid,
        referenceid: this.referenceid,
        order_id: this.orderid,
        paymentGatewayName: this.paymentGatewayNameid,
        membersInvolved: this.membersId.toString(),
        Selected_dates: this.dateRange1,
        Selected_time: JSON.stringify(this.selectedBooking_time),
        trainingcenter_categoryid: this.storeTriningCategoryId,
      });
      this.services
        .postRequest('patientTrainingCenterBooking', apiData)
        .subscribe(async (res) => {
          await loading.dismiss();
          if (res.status == 1 && localStorage.getItem('cardType') == 'Knet') {
            this.showKnetPaymentDetals(response, this.addCall.title620);
            setTimeout(() => {
              this.playSound();
            }, 1000);
          } else if (localStorage.getItem('cardType') == 'MasterCard') {
            this.router.navigate(['/payment', { paymentstatus: 1 }]);
          }
        });
    }
  }
  playSound() {
    let audio = new Audio();
    audio.src = '../assets/audio/tick.mp3';
    audio.load();
    audio.play();
  }

  gatewayFunction(res: any, paymentGateway: any) {
    if (res.status == '1') {
      this.paymentid = res.resultid;
      this.referenceid = res.sessionid;
      this.orderid = res.orderId;
      this.paymentGatewayNameid = res.paymentGatewayName;
      this.insertBooking(res);
    } else if (res.status == '2') {
      this.AlertInfo('payment canceled', 0);
    } else {
      if (paymentGateway == 'KNET') {
        this.showKnetPaymentDetals(res, 'Payment Failure Details');
      } else {
        this.AlertInfo('payment canceled', 0);
      }
    }
  }

  wayOfBookingListpages(page) {
    this.StoreWayBookingPageFlow = page;
    this.pageNo = 1;
    this.scrollEvent = null;
    if (page == 'bookingList') {
      this.bookingList();
    } else if (page == 'bookingHisList') {
      this.bookingHis();
    }
  }
  datefor: any;

  bookingList() {
    this.getPatientBasicDetails();
    this.headerValue = this.addCall.title143;
    this.nextcount2 = 0;
    if (this.pageNo == 1) {
      this.length = null;
    }

    this.presentView = 'historyPage';
    this.bookings = true;
    this.canBookings = false;
    this.viewBookingInfo = false;
    this.backValue = 'step1';
    this.headerValue = this.addCall.title143;

    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      pageno: this.pageNo,
      limit: 1000,
    });
    this.services
      .postRequest1('getPatientTrainingCenterBookingDetails', apiData)
      .subscribe((res) => {
        res.status == 1
          ? (this.nextcount2 = res.data[0].nextCount)
          : (this.nextcount2 = 0);
        if (this.refEvent) {
          this.refEvent.target.complete();
        }
        if (this.scrollEvent) {
          this.scrollEvent.target.complete();
        }
        if (this.pageNo == 1) {
          this.length = res.status;
        }
        if (res.msg == 'Success') {
          this.length = 1;
          if (this.pageNo != 1 && this.searchStatus == false) {
            for (let item of res.data[0].details) {
              this.storeBookingList.push(item);
            }
          } else {
            this.storeBookingList = null;
            this.EmtyData = res.msg;
            this.storeBookingList = res.data[0].details;
          }
        }
      });
  }

  bookingHis() {
    this.nextcount2 = 0;
    if (this.pageNo == 1) {
      this.length = null;
    }
    this.presentView = 'historyPage';
    this.bookings = false;
    this.canBookings = true;
    this.viewBookingInfo = false;
    this.backValue = 'step1-1';
    this.headerValue = this.addCall.title134;
    this.headerName = '';
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      pageno: this.pageNo,
      limit: 10,
    });
    this.services
      .postRequest('getPatientTrainingCenterBookingHistoryDetails', apiData)
      .subscribe((res) => {
        res.status == 1
          ? (this.nextcount2 = res.data[0].nextCount)
          : (this.nextcount2 = 0);
        if (this.pageNo == 1) {
          this.length = res.status;
        }
        if (this.refEvent) {
          this.refEvent.target.complete();
        }
        if (this.scrollEvent) {
          this.scrollEvent.target.complete();
        }

        if (res.status == 1) {
          this.length = 1;
          if (this.pageNo != 1 && this.searchStatus == false) {
            for (let item of res.data[0].details) {
              this.storeBkgHisList.push(item);
            }
            this.storeBkgHisList.reverse();
          } else {
            this.storeBkgHisList = null;
            this.EmtyData = res.msg;
            this.storeBkgHisList = res.data[0].details;
          }
        }
      });
  }

  viewBookingDetail(value, bookingId, tcbooking) {
    this.ChangeEventSports.emit('profile');
    this.isShowHeaderValue = true;
    this.showformatsltdate = [];
    this.bookingsCompleted = [];
    this.bookingsRemaining = [];
    this.headerName = '';
    this.slectedday = [];
    this.presentView = 'viewBookingInfo';
    this.EmtyData = null;
    if (this.mybackschedule == true) {
      this.backValue = 'step1-8';
    } else {
      this.backValue = value;
    }
    this.mybackschedule = false;
    this.storeBookingId = bookingId;
    this.storetcid = tcbooking;
    let apiData = JSON.stringify({
      trainingCenterBookingId: bookingId,
      patientId: localStorage.getItem('patient_id'),
      TCBookingId: this.storetcid,
    });
    this.isFetchingTrainingCenterBookingDetails = true;
    this.services
      .postRequest('particularTrainingCenterBookingDetails', apiData)
      .subscribe((res) => {
        this.isFetchingTrainingCenterBookingDetails = false;
        this.EmtyData = res.msg;
        if (res) {
          debugger
          this.particularBookingInfo = res.data[0];
          let datestore = [];
          datestore.push(this.particularBookingInfo.selected_dates.split(','));
          let selectedDates = []
          datestore[0].forEach((item)=>{
            selectedDates.push(new Date(item))
          });
          let setBookHours = [];
          selectedDates.forEach((item)=>{
            setBookHours.push(item.setHours(0, 0, 0, 0))
          })
          this.bookingsCompleted = selectedDates.filter(element => element <= new Date);
          this.bookingsRemaining = selectedDates.filter(element => element > new Date);

          datestore[0].forEach((i) => {
            this.slectedday.push(this.getFormattedDateTime(i, 'Date1'));
          });
          this.showformatsltdate = this.slectedday.slice(0, 2).join(', ');
          this.bookings = false;
          this.canBookings = false;
          this.viewBookingInfo = true;
          this.membernamedetails = res.data[0].temp_member_name.split(',');
          this.amountpermember =
            this.membernamedetails.length *
            this.particularBookingInfo.trcr_cost;
          this.conslocation = res.data[0].vendor_address;
          this.Vendor_Name = res.data[0].trainingCenterName;
          this.Sports_lat_lon = res.data[0].vendor_latlong;
          this.dealOption = this.particularBookingInfo.deal_option;
          this.dealValue = this.particularBookingInfo.deal_value;
          this.dayBwhorking = this.particularBookingInfo.programdays.split(',');
          var hrsmintxt = this.particularBookingInfo.duration.slice(0, 2);
          if (hrsmintxt == '00') {
            this.hrsText = 'min';
          } else {
            this.hrsText = 'hrs';
          }
          if (this.dealOption == 'Amount') {
            this.dealType = 'KWD';
            this.finalPay =
              Number(this.amountpermember) - Number(this.dealValue);
          } else if (this.dealOption == 'Percentage') {
            this.dealType = '%';
            this.finalPay =
              Number(this.amountpermember) -
              (Number(this.amountpermember) * Number(this.dealValue)) / 100;
          } else {
            this.finalPay = this.amountpermember;
          }
        }
      });
  }

  viewBookingHistoryDetail(value, bookingId, tcbooking) {
    this.showformatsltdate = [];
    this.slectedday = [];
    this.presentView = 'viewHistoryBookingInfo';
  }

  myschereschduledDate: any = [];
  reShedule(id, ind, name, item) {
    this.reschdulefrom = [];
    this.reschduleto = [];
    this.partTrainBookDetl = item;
    this.rescheduledSelectedDate = item.selected_dates.split(',');
    this.myschereschduledDate = [];
    let rescheduledDate = null;
    if (this.partTrainBookDetl.rescheduledFromDate != null) {
      rescheduledDate = this.partTrainBookDetl.rescheduledFromDate.split(',');
      rescheduledDate.forEach((item) => {
        this.myschereschduledDate.push(new Date(item).toDateString());
      });
    }
    this.presentView = 'reShedulePage';
    this.isShowHeaderValue = true;
    this.ChangeEventSports.emit('profile');
    this.backValue = 'step1-1';
    this.headerValue = '';
    this.dayBwhorking = item.programdays.split(',');
    this.headerName = name;
    this.clupWorkingHr();
    let resform = null;
    let resto = null;
    if (this.partTrainBookDetl.rescheduledFromDate != null) {
      resform = this.partTrainBookDetl.rescheduledFromDate.split(',');
      resto = this.partTrainBookDetl.rescheduledToDate.split(',');
      resform.forEach((item) => {
        this.reschdulefrom.push(new Date(item).toDateString());
      });
      resto.forEach((item) => {
        this.reschduleto.push(new Date(item).toDateString());
      });
    }
    this.optionsMulti = {
      pickMode: 'range',
      weekdays: [
        this.addCall.title411,
        this.addCall.title412,
        this.addCall.title413,
        this.addCall.title414,
        this.addCall.title415,
        this.addCall.title416,
        this.addCall.title417,
      ],
    };

    let fromDate = item.from_date;
    let toDate = item.to_date;
    this.nextBtn = true;
    this.prevBtn = false;
    this.myFromDate = new Date(
      fromDate.split('-')[0],
      fromDate.split('-')[1] - 1,
      fromDate.split('-')[2]
    );
    this.myToDate = new Date(
      toDate.split('-')[0],
      toDate.split('-')[1] - 1,
      toDate.split('-')[2]
    );
    this.showsheduledate =
      this.myFromDate.toString().split(' ')[0] +
      ', ' +
      this.myFromDate.toString().split(' ')[1] +
      ' ' +
      this.myFromDate.toString().split(' ')[2];
    this.chkCrnDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.rescddays = [];
    this.rescddate = [];
    this.getBkgDateCaleForResch(new Date(fromDate), new Date(toDate));
    this.dateRange = {
      from: new Date(
        fromDate.split('-')[0],
        fromDate.split('-')[1].split('')[1] - 1,
        fromDate.split('-')[2] + 1
      ),
      to: new Date(
        toDate.split('-')[0],
        toDate.split('-')[1].split('')[1] - 1,
        toDate.split('-')[2] + 1
      ),
    };
    this.rescdamt = this.storeBookingList[ind].amount;
    this.toreschedule = [];
    this.dateArr = [];
  }

  rescheduleconfirm() {
    if (this.isButtonDisabled) {
      return; // If button is already clicked, do nothing
    }

    this.isButtonDisabled = true;

    this.toreschedule.forEach((item, i) => {
      if (this.rescheduledSelectedDate.includes(item)) {
        this.rescheduledSelectedDate.splice(
          this.rescheduledSelectedDate.indexOf(item),
          1
        );
      }
    });
    this.dateArr.forEach((item, i) => {
      this.rescheduledSelectedDate.push(item);
    });
    if (
      this.dateArr.length == this.toreschedule.length &&
      this.dateArr.length != 0 &&
      this.toreschedule.length != 0
    ) {
      let apiData = JSON.stringify({
        oldBookingId: this.partTrainBookDetl.trainingCenterBookingId,
        patientId: localStorage.getItem('patient_id'),
        trainingCenterId: this.partTrainBookDetl.trainingCenterId,
        packageId: this.partTrainBookDetl.packageid,
        fromDate: new Date(this.partTrainBookDetl.from_date)
          .toISOString()
          .split('T')[0],
        toDate: new Date(this.partTrainBookDetl.to_date)
          .toISOString()
          .split('T')[0],
        bookedDate: new Date().toISOString().split('T')[0],
        amount: this.rescdamt,
        paymentStatus: '1',
        isMember: 2,
        tempMemberName: this.partTrainBookDetl.patientName,
        ReScheduleFromDate: this.toreschedule.join(','),
        ReScheduleToDate: this.dateArr.join(','),
        rescheduledSelectedDate: this.rescheduledSelectedDate.join(','),
      });
      this.services
        .postRequest('patientTrainingCenterBookingReschedule', apiData)
        .subscribe((res) => {
          if (res.status == 1) {
            this.AlertInfo('Rescheduled successfully!', res.status);
            this.pageNo = 1;
            this.storeBookingList = null;
            this.EmtyData = null;
            this.scrollEvent = null;
            this.ChangeEventSports.emit('isTrainerBackBooking');
            this.isShowHeaderValue = true;
            this.bookingList();
          } else {
            this.AlertInfo(res.msg, 0);
          }
        });
    } else if (this.dateArr.length < this.toreschedule.length) {
      this.AlertInfo(this.addCall.title453, 2);
    } else if (this.dateArr.length > this.toreschedule.length) {
      this.AlertInfo(this.addCall.title454, 2);
    } else if (this.dateArr.length == 0 && this.toreschedule.length > 0) {
      this.AlertInfo(this.addCall.title454, 2);
    } else if (this.dateArr.length > 0 && this.toreschedule.length == 0) {
      this.AlertInfo(this.addCall.title453, 2);
    }
  }

  reschdulefrom: any = [];
  reschduleto: any = [];
  myschereschdulefrom: any = [];
  myschereschduleto: any = [];

  viewMyShedule() {
    this.myschereschdulefrom = [];
    this.myschereschduleto = [];
    this.presentView = 'viewMyShcedule';
    this.ChangeEventSports.emit('profile');
    this.isShowHeaderValue = true;
    this.backValue = 'step1-3';
    this.mybackschedule = true;
    this.headerValue = this.particularBookingInfo.trcr_package_name; //"My Schedule";
    this.particularCenterInfo = this.particularBookingInfo;
    this.getCenterWorkingHr =
      this.particularBookingInfo.trainingCenterWorkinghours;
    this.clupWorkingHr();
    this.optionsMulti = {
      pickMode: 'range',
      weekdays: [
        this.addCall.title411,
        this.addCall.title412,
        this.addCall.title413,
        this.addCall.title414,
        this.addCall.title415,
        this.addCall.title416,
        this.addCall.title417,
      ],
    };
    let fromDate = this.particularBookingInfo.from_date.split('T')[0];
    let showdate = this.particularBookingInfo.from_date;
    this.showsheduledate =
      new Date(showdate).toString().split(' ')[0] +
      ', ' +
      new Date(showdate).toString().split(' ')[1] +
      ' ' +
      new Date(showdate).toString().split(' ')[2];
    let toDate = this.particularBookingInfo.to_date.split('T')[0];
    let dates = this.getBtwDays(new Date(fromDate), new Date(toDate));
    if (dates.reminingDays < 10) {
      this.remaingDates = dates.reminingDays;
    } else {
      this.remaingDates = dates.reminingDays;
    }
    // this.option.percent = (dates.reminingDays / this.particularBookingInfo.trcr_session) * 100;
    this.option.percent = (this.bookingsRemaining.length/ this.particularBookingInfo.trcr_session) * 100;

    this.compDate = this.getBtwDayslist.completedday;
    // this.option1.percent = (this.compDate / this.particularBookingInfo.trcr_session) * 100;
    this.option1.percent = (this.bookingsCompleted.length / this.particularBookingInfo.trcr_session) * 100;

    let resform = null;
    let resto = null;
    if (this.particularBookingInfo.reschedule_date != null) {
      resform = this.particularBookingInfo.rescheduledFromDate.split(',');
      resto = this.particularBookingInfo.rescheduledToDate.split(',');
      resform.forEach((item) => {
        this.myschereschdulefrom.push(new Date(item).toDateString());
      });
      resto.forEach((item) => {
        this.myschereschduleto.push(new Date(item).toDateString());
      });
    }
    this.nextBtn = true;
    this.prevBtn = false;
    this.myFromDate = new Date(
      fromDate.split('-')[0],
      fromDate.split('-')[1] - 1,
      fromDate.split('-')[2]
    );
    this.myToDate = new Date(
      toDate.split('-')[0],
      toDate.split('-')[1] - 1,
      toDate.split('-')[2]
    );
    this.chkCrnDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.crnDate = new Date().getDate();
    this.crnYear = new Date().getFullYear();
    this.crnMonth = new Date().getMonth() + 1;
    this.getBkgDateCaleForResch(new Date(fromDate), new Date(toDate));
    this.dateRange = {
      from: new Date(
        fromDate.split('-')[0],
        fromDate.split('-')[1].split('')[1] - 1,
        fromDate.split('-')[2] + 1
      ),
      to: new Date(
        toDate.split('-')[0],
        toDate.split('-')[1].split('')[1] - 1,
        toDate.split('-')[2] + 1
      ),
    };
    let date = new Date(
      fromDate.split('-')[0],
      fromDate.split('-')[1].split('')[1] - 1,
      fromDate.split('-')[2]
    );
  }

  getBtwDays(start, end) {
    let remDate = [];
    let completeddates = [];
    for (
      var arr = [], dt = new Date(start);
      dt <= end;
      dt.setDate(dt.getDate() + 1)
    ) {
      arr.push(new Date(dt));
      let date1 = new Date(dt);
      let date2 = new Date();
      date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      if (date1 > date2 && !this.disabelDay.includes(date1.getDay())) {
        remDate.push(new Date(dt));
      } else if (date1 < date2 && !this.disabelDay.includes(date1.getDay())) {
        completeddates.push(new Date(dt));
      }
    }
    this.getBtwDayslist = {
      totalDays: arr.length,
      reminingDays: remDate.length,
      completedday: completeddates.length,
    };
    return this.getBtwDayslist;
  }

  reFundOption(bookingId) {
    this.showRefundPopUp = !this.showRefundPopUp;
    this.storeBookingId = bookingId;
  }

  async cancelBkg(bookingId: any, bookingAmnt: any, patId: any) {
    this.storeBookingId = bookingId;
    this.bookingAmnt = bookingAmnt;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt,
      },
    });
    modal.onDidDismiss().then((data) => {
      const res = data;
      if (res.data != null) {
        this.cancelBookingApi(patId);
      }
    });
    return await modal.present();
  }

  cancelBookingApi(patId: any) {
    let apiData = JSON.stringify({
      patientId: patId,
      trainingCenterBookingId: this.storeBookingId,
    });
    this.services
      .postRequest('patientTrainingCenterCancelBooking', apiData)
      .subscribe((res) => {
        if (res.status == 1) {
          if (res.data[0].msgcode == 1) {
            this.AlertInfo(this.addCall.title449, res.status);
          } else if (res.data[0].msgcode == 2) {
            this.AlertInfo(this.addCall.title450, res.status);
          } else if (res.data[0].msgcode == 3) {
            this.AlertInfo(this.addCall.title451, 0);
          }
          this.storeBookingList = null;
          this.EmtyData = null;
          this.pageNo = 1;
          this.scrollEvent = null;
          this.bookingList();
        } else {
          this.AlertInfo(res.msg, res.status);
        }
      });
  }

  // Assuming this is inside a class or component method
  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return '';
    }

    let Value;
    switch (callFor) {
      case 'Time':
        if (dateTime.indexOf('T') > -1) {
          Value = dateTime.split('T')[1];
        } else if (dateTime.indexOf(' ') > -1) {
          Value = dateTime.split(' ')[1];
        } else {
          Value = dateTime;
        }
        var hourEnd = Value.indexOf(':');
        var H = +String(Value).substr(0, hourEnd);
        var h = H % 12 || 12;
        var ampm = H < 12 || H === 24 ? 'AM' : 'PM';
        let timeString = h + String(Value).substr(hourEnd, 3) + ' ' + ampm;
        if (h < 10) {
          timeString = '0' + timeString; // Ensure leading zero if hour < 10
        }
        return timeString;

      case 'Date':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy');
        } else {
          let dateCall = new Date(dateTime);
          var months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          var day = String(dateCall.getDate()).padStart(2, '0');
          var arDate =
            day +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }

      case 'DateTime':
        return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy h:mm a');

      case 'Date1':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd-MMM-yy');
        } else {
          let dateCall = new Date(dateTime);
          var months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          var day = String(dateCall.getDate()).padStart(2, '0');
          var arDate =
            day +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }

      case 'datefor':
        return this.datepipeTransform(new Date(dateTime), 'yyyy-MM-dd');

      default:
        return ''; // Handle default case or return an empty string
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  flowrepeat(centerid: any, bookingId: any, value: any, i: any, item: any) {
    this.repeatpage = true;
    this.dateRange1 = null;
    this.presentView = 'clubProfileInforepeat';
    this.presentView1 = 'clubProfileInfo1';
    this.isShowHeaderValue = true;
    this.ChangeEventSports.emit('profile');
    this.sdhowpro = 0;
    this.showbook = false;
    this.selected_program = null;
    this.getMedia(centerid);
    this.empty = null;
    this.storeTrngCenterId = centerid;
    this.particularCenterInfo = null;
    this.reviewpercenage = item.review_percentage;
    this.isShow = true;
    this.showOffers = true;
    this.showOffInfo = false;
    this.conspath = item.vendor_filename;
    this.consname = item.trainingCenterName;
    this.conslocation = item.vendor_address;
    this.Like = item.likes_count;
    this.likestatus = item.isLiked;
    this.storeTriningCategoryId = item.trainingcenter_catid;
    this.headerValue = item.trainingCenterName;
    this.packageid = item.packageid;
    this.getparticulartrainer_cerntrdet('Repeat', item.packageid);
  }

//old one
  // Reschedulefun(value: any, ind: any) {
  //   this.presentView == '';
  //   let dateentry: any;
  //   if (
  //     value.fullDate >= this.myFromDate &&
  //     value.fullDate >= this.chkCrnDate &&
  //     value.fullDate <= this.myToDate
  //   ) {
  //     let date = new Date(value.fullDate);
  //     let formtDate =
  //       date.getFullYear() +
  //       '-' +
  //       ('0' + (date.getMonth() + 1)).slice(-2) +
  //       '-' +
  //       ('0' + date.getDate()).slice(-2);
  //     if (!this.toreschedule.includes(formtDate)) {
  //       this.toreschedule.push(formtDate);
  //     } else {
  //       this.toreschedule.splice(this.toreschedule.indexOf(formtDate), 1);
  //     }
  //     if (
  //       this.rescddays.indexOf(value.fullDate) > -1 ||
  //       String(this.rescddays[ind]) == value.fullDate
  //     ) {
  //       this.rescddays.splice(this.rescddays.indexOf(value.fullDate), 1, '');
  //     } else {
  //       this.rescddays[ind] = value.fullDate;
  //     }
  //   }

  //   if (this.dateArr.length <= this.toreschedule.length - 1) {
  //     if (value.fullDate > this.myToDate) {
  //       let date = new Date(value.fullDate);
  //       let formtDate =
  //         date.getFullYear() +
  //         '-' +
  //         ('0' + (date.getMonth() + 1)).slice(-2) +
  //         '-' +
  //         ('0' + date.getDate()).slice(-2);
  //       if (!this.dateArr.includes(formtDate)) {
  //         this.dateArr.push(formtDate);
  //       } else {
  //         this.dateArr.splice(this.dateArr.indexOf(formtDate), 1);
  //       }
  //       if (!this.rescddate.includes(value.fullDate)) {
  //         this.rescddate[ind] = value.fullDate;
  //       } else {
  //         let index = this.rescddate.indexOf(this.rescddate[ind]);
  //         this.rescddate.splice(ind, 1, '');
  //       }
  //     }
  //   } else {
  //     let date = new Date(value.fullDate);
  //     let formtDate =
  //       date.getFullYear() +
  //       '-' +
  //       ('0' + (date.getMonth() + 1)).slice(-2) +
  //       '-' +
  //       ('0' + date.getDate()).slice(-2);
  //     if (this.dateArr.includes(formtDate)) {
  //       this.dateArr.splice(this.dateArr.indexOf(formtDate), 1);
  //     }
  //     if (this.rescddate.includes(value.fullDate)) {
  //       let index = this.rescddate.indexOf(this.rescddate[ind]);
  //       this.rescddate.splice(ind, 1, '');
  //     }
  //   }
  // }


  dateArr: any = [];
  toreschedule: any = [];

  Reschedulefun(value: any, ind: any) {
    this.presentView == '';
    let dateentry: any;
    if (
      value.fullDate >= this.myFromDate &&
      value.fullDate >= this.chkCrnDate &&
      value.fullDate <= this.myToDate
    ) {
      let date = new Date(value.fullDate);
      let formtDate =
        date.getFullYear() +
        '-' +
        ('0' + (date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + date.getDate()).slice(-2);
      if (!this.toreschedule.includes(formtDate)) {
        this.toreschedule.push(formtDate);
      } else {
        this.toreschedule.splice(this.toreschedule.indexOf(formtDate), 1);
      }
      let checker = []
       checker.push(this.rescddays.find(element => String(element) == String(value.fullDate)))
      if (this.rescddays.indexOf(value.fullDate) > -1 || checker?.length > 0 && checker[0] != undefined) {
        const spliceIndex = this.rescddays.findIndex(element => String(element) == String(value.fullDate));
        this.rescddays.splice(spliceIndex, 1);
      } else {
        this.rescddays.push(value.fullDate);
      }
    }

    if (this.dateArr.length <= this.toreschedule.length - 1) {
      if (value.fullDate > this.myToDate) {
        let date = new Date(value.fullDate);
        let formtDate =
          date.getFullYear() +
          '-' +
          ('0' + (date.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + date.getDate()).slice(-2);
        if (!this.dateArr.includes(formtDate)) {
          this.dateArr.push(formtDate);
        } else {
          this.dateArr.splice(this.dateArr.indexOf(formtDate), 1);
        }
        // if (!this.rescddate.includes(value.fullDate)) {
        //   this.rescddate.push(value.fullDate);
        // } else {
        //   let index =  this.rescddate.findLastIndex(element => String(element) == String(value.fullDate))
        //   this.rescddate.splice(index, 1);
        // }
        if (!this.rescddate.find(item=> String(item) == String(value.fullDate))) {
          this.rescddate.push(value.fullDate);
        } else {
          let index =  this.rescddate.findLastIndex(element => String(element) == String(value.fullDate))
          this.rescddate.splice(index, 1);
        }
      }
    } else {
      let date = new Date(value.fullDate);
      let formtDate =
        date.getFullYear() +
        '-' +
        ('0' + (date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + date.getDate()).slice(-2);
        const checker = new Date(this.dateArr[this.dateArr.length - 1]);
        checker.setHours(0, 0, 0, 0)
        this.dateArr.splice(-1, 1);
      // if (this.dateArr.includes(formtDate)) {
      //   this.dateArr.splice(this.dateArr.indexOf(formtDate), 1);
      // }
      this.rescddate.splice(-1, 1);
      // if (this.rescddate.includes(value.fullDate)) {
      //   let index = this.rescddate.indexOf(this.rescddate[ind]);
      //   this.rescddate.splice(ind, 1, '');
      // }
    }
  }
  //--------check reschedule date--------------//

  getBkgDateCaleForResch(fromDate, toDate) {
    this.storeDates = [];
    const FromDate = new Date(fromDate);
    const ToDate = new Date(toDate);
    let dateArray = String(fromDate).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    let prevDate = new Date(
      FromDate.getFullYear(),
      FromDate.getMonth(),
      0
    ).getDay();
    if (prevDate < 6) {
      for (let i = prevDate; i >= 0; i--) {
        this.storeDates.push({
          fullDate: ' ',
          year: ' ',
          month: ' ',
          date: ' ',
          dayId: ' ',
          dateid: '',
          f_date: '',
        });
      }
    }

    let monthEnd = new Date(
      FromDate.getFullYear(),
      FromDate.getMonth() + 1,
      0
    ).getDate();
    for (let i = 1; i <= monthEnd; i++) {
      if (i == 1) {
        this.displayMonth = new Date(
          FromDate.getFullYear(),
          FromDate.getMonth(),
          i
        );
      }
      this.storeDates.push({
        fullDate: new Date(FromDate.getFullYear(), FromDate.getMonth(), i),
        year: FromDate.getFullYear(),
        month: FromDate.getMonth() + 1,
        date: i,
        dayId: new Date(
          FromDate.getFullYear(),
          FromDate.getMonth(),
          i
        ).getDay(),
        dateid: new Date(
          FromDate.getFullYear(),
          FromDate.getMonth(),
          i
        ).toDateString(),
        f_date: new Date(FromDate).toISOString().split('T')[0],
      });
    }
    let difftime;
    if (this.myFromDate <= this.chkCrnDate) {
      difftime = this.myToDate.getTime() - this.chkCrnDate.getTime();
    } else {
      difftime = this.myToDate.getTime() - this.myFromDate.getTime();
    }
    this.diffDays = Math.ceil(difftime / (1000 * 3600 * 24)) + 1;
  }

  nextMonth() {
    this.nextBtn = false;
    this.prevBtn = true;
    let nextMonth = new Date(
      this.displayMonth.getFullYear(),
      this.displayMonth.getMonth() + 1,
      1
    );
    let dateArray = String(nextMonth).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.getBkgDateCaleForResch(new Date(nextMonth), new Date(this.myToDate));
  }
  prevMonth() {
    this.nextBtn = true;
    this.prevBtn = false;
    let prevMonth = new Date(
      this.displayMonth.getFullYear(),
      this.displayMonth.getMonth() - 1,
      1
    );
    let dateArray = String(prevMonth).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.getBkgDateCaleForResch(new Date(prevMonth), new Date(this.myToDate));
  }

  //--------------------------BACK FLOW ONLY------------------------------//

  //--------------------------changed by saran------------------------------//

  goBack(value) {
    debugger;
    switch (value) {
      case 'step0':
        this.router.navigate(['tabs/home']);
        this.commonheadervalue = 'trainerheader';
        break;
      case 'step1':
        this.getdetail = null;
        this.searchValue1 = '';
        this.pageNo = 1;
        this.storeTrgCentrCategory = null;
        this.storeParticulerCategoryInfo = [];
        this.isReviewsVisible = true;
        this.commonheadervalue = 'trainerheader';
        this.showCatPage();
        break;
      case 'step2':
        setTimeout(() => {
          this.scrolltop();
        }, 500);
        this.showcoment = false;
        this.ProgramName = null;
        this.dealserviceid = null;
        this.calenderMode = 'multi';
        this.openClups(this.storeTriningCategoryId);
        this.presentView = 'listClubPage';
        this.backValue = 'step1';
        this.headerValue = 'clubs';
        this.commonheadervalue = 'trainerheader';
        this.clearSelectedDates();
        break;
      case 'step3':
        this.showcoment = false;
        this.ProgramName = null;
        this.calenderMode = 'multi';
        this.presentView = 'listClubPage';
        this.backValue = 'step1';
        this.headerValue = 'clubs';
        this.commonheadervalue = 'trainerheader';
        this.isShow = true;
        this.showOffers = true;
        this.showOffInfo = false;
        this.backValue = 'step2';
        this.headerValue = this.particularCenterInfo.trainerName;
        this.optionsMulti = {
          pickMode: this.calenderMode,
          weekdays: [
            this.addCall.title411,
            this.addCall.title412,
            this.addCall.title413,
            this.addCall.title414,
            this.addCall.title415,
            this.addCall.title416,
            this.addCall.title417,
          ],
          disableWeeks: this.disabelDay,
        };
        if (this.repeatpage == true) {
          this.ChangeEventSports.emit('isSportsBack');
          this.isShowHeaderValue = false;
          this.bookingHis();
        }

        break;
      case 'step4':
        this.backValue = 'step3';
        this.openOffInfo(this.storeOfferIndex);
        this.optionsMulti = {
          pickMode: this.calenderMode,
          weekdays: [
            this.addCall.title411,
            this.addCall.title412,
            this.addCall.title413,
            this.addCall.title414,
            this.addCall.title415,
            this.addCall.title416,
            this.addCall.title417,
          ],
          disableWeeks: this.disabelDay,
        };
        break;
      case 'step5':
        this.presentView = 'clubProfileInfo';
        this.presentView1 = 'clubProfileInfo1';
        this.isShow = true;
        this.showOffers = true;
        this.showOffInfo = false;
        this.isConfirmed = false;
        this.backValue = 'step2';
        this.headerValue = this.particularCenterInfo.trainerName;
        this.optionsMulti = {
          pickMode: this.calenderMode,
          weekdays: [
            this.addCall.title411,
            this.addCall.title412,
            this.addCall.title413,
            this.addCall.title414,
            this.addCall.title415,
            this.addCall.title416,
            this.addCall.title417,
          ],
          disableWeeks: this.disabelDay,
        };
        break;
      case 'step6':
        this.getPatientBasicDetails();
        this.backValue = 'step5';
        break;
      case 'step1-5':
        this.presentView = 'clubProfileInfo';
        this.presentView1 = 'clubProfileInfo1';
        this.showOffInfo = true;
        this.headerValue = this.particularCenterInfo.trainerName;
        this.backValue = 'step1-2';
        break;
      case 'step1-1':
        this.pageNo = 1;
        this.storeBookingList = null;
        this.EmtyData = null;
        this.scrollEvent = null;
        this.StoreWayBookingPageFlow = 'bookingList';
        this.ChangeEventSports.emit('isTrainerBackBooking');
        this.isShowHeaderValue = false;
        this.bookingList();
        break;
      case 'step1-2':
        this.showbook = false;
        this.showcoment = false;
        this.pageNo = 1;
        this.storeBkgHisList = null;
        this.EmtyData = null;
        this.ChangeEventSports.emit('isSportsBack');
        this.isShowHeaderValue = false;
        this.bookingHis();
        break;
      case 'step1-3':
        this.pageNo = 1;
        this.storeBookingList = null;
        this.EmtyData = null;
        this.scrollEvent = null;
        this.StoreWayBookingPageFlow = 'bookingList';
        this.ChangeEventSports.emit('isSportsBack');
        this.isShowHeaderValue = false;
        this.viewBookingDetail(value, this.storeBookingId, this.storetcid);
        break;
      case 'step1-8':
        this.ChangeEventSports.emit('isSportsBack');
        this.isShowHeaderValue = false;
        this.bookingList();
        break;

      default:
        this.isMuteVideo = false;
        break;
    }
    this.isConfirmed = false;
  }
  showcoment: boolean = false;

  showHide() {
    if (!this.isReviewsVisible) {
      this.revArr1 = [this.ReviewArraybox[0]];
    } else {
      this.revArr1 = this.ReviewArraybox;
    }
    this.isReviewsVisible = !this.isReviewsVisible;
  }

  async reviewPopup(
    Id: any,
    Img: any,
    Name: any,
    reviewcount,
    training_centerbooking_id
  ) {
    if (reviewcount == 0) {
      const alert = await this.modalCtrl.create({
        component: ReviewPage,
        cssClass: 'review-class',
        componentProps: {
          Id: Id,
          Img: Img,
          Name: Name,
          From: 'Training Center',
          bookingId: training_centerbooking_id,
        },
      });
      alert.onDidDismiss().then((data) => {
        if (data.data == 'dismiss') {
          this.wayOfBookingListpages('bookingHisList');
        }
      });
      await alert.present();
    }
  }

  segmentChanged(ev: any) {
    if (ev.detail.value == 'indoor') {
      this.segtypeval = 1;
      this.showCatPage();
    } else {
      this.segtypeval = 2;
      this.showCatPage();
    }
  }

  isElementInViewPort(el) {
    const rect = el.getBoundingClientRect();
    const top = Math.round(rect.top);
    const left = Math.round(rect.left);
    const bottom = Math.round(rect.bottom);
    const right = Math.round(rect.right);
    return (
      top >= 0 &&
      left >= 0 &&
      bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  pausePlay(id, mid) {
    const uniqueVideoId = `VideoLab${id}${mid}`;
    if (this.currentPlaying?.id !== uniqueVideoId) {
      if (this.currentPlaying) this.currentPlaying.pause();
      this.currentPlaying = document.getElementById(uniqueVideoId);
    }
    if (this.currentPlaying) {
      this.currentPlaying.paused
        ? this.currentPlaying.play()
        : this.currentPlaying.pause();
    }
  }
  didScrollEvent(event) {
    try {
      if (this.Addcheckvarible) return;
      const inViewPort = this.vdoPlayer.find((player) =>
        this.isElementInViewPort(player.nativeElement)
      );
      if (inViewPort && this.currentPlaying !== inViewPort.nativeElement) {
        if (this.currentPlaying) this.currentPlaying.pause();
        this.currentPlaying = inViewPort.nativeElement;
        this.currentPlaying.paused
          ? this.currentPlaying.play()
          : this.currentPlaying.pause();
      } else if (!inViewPort && this.currentPlaying) {
        this.currentPlaying.pause();
        this.currentPlaying = null;
      }
    } catch (err) {
      console.error(err);
    }
  }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
      this.presentToast('Enter Number only');
    }
  }

  alphabetOnlyValidation(event: any) {
    const pattern = /^[A-Za-z\s]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
      this.presentToast('Enter alphabets only');
    }
  }

  checklimit(event: any) {
    if (this.getMemHeight.length <= 3) {
      this.getMemHeight = this.getMemHeight;
    } else {
      this.getMemHeight != this.getMemHeight;
    }
  }

  makeLike(i, trainingCenterId, like, from, isLiked) {
    debugger;
    try {
      if (this.storeParticulerCategoryInfo[i].isLiked == null) {
        this.storeParticulerCategoryInfo[i].isLiked = 1;
        this.storeParticulerCategoryInfo[i].likes_count =
          Number(this.storeParticulerCategoryInfo[i].likes_count) + 1;
      }
      if (from == 2) {
        if (this.storeParticulerCategoryInfo[i].isLiked == 0) {
          this.storeParticulerCategoryInfo[i].isLiked = 1;
          this.storeParticulerCategoryInfo[i].likes_count =
            Number(this.storeParticulerCategoryInfo[i].likes_count) + 1;
        }
      } else if (from == 1) {
        if (this.storeParticulerCategoryInfo[i].isLiked == 0) {
          this.storeParticulerCategoryInfo[i].isLiked = 1;
          this.storeParticulerCategoryInfo[i].likes_count =
            Number(this.storeParticulerCategoryInfo[i].likes_count) + 1;
        } else if (this.storeParticulerCategoryInfo[i].isLiked == 1) {
          this.storeParticulerCategoryInfo[i].isLiked = 0;
          this.storeParticulerCategoryInfo[i].likes_count =
            Number(this.storeParticulerCategoryInfo[i].likes_count) - 1;
        }
      }
      let data = JSON.stringify({
        vendor_id: trainingCenterId,
        like: like,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Sports',
        isLiked: isLiked == 1 ? 'true' : 'false',
      });
      this.services.postRequestDoc('UpdateVendorLikes', data).subscribe(
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (err) {
      console.log(err);
    }
  }

  makeLikeprofile(i, trainingCenterId, like, from, isLiked) {
    debugger;
    try {
      if (this.likestatus == null) {
        this.likestatus = 1;
        this.Like = Number(this.Like) + 1;
      }
      if (from == 2) {
        if (this.likestatus == 0) {
          this.likestatus = 1;
          this.Like = Number(this.Like) + 1;
        }
      } else if (from == 1) {
        if (this.likestatus == 0) {
          this.particularCenterInfo.isLiked = 1;
          this.likestatus = 1;
          this.Like = Number(this.Like) + 1;
        } else if (this.likestatus == 1) {
          this.particularCenterInfo.isLiked = 0;
          this.likestatus = 0;
          this.Like = Number(this.Like) - 1;
        }
      }
      if (this.mklike) {
        this.mklike.unsubscribe();
      }

      let data = JSON.stringify({
        vendor_id: trainingCenterId,
        like: like,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Sports',
        isLiked: isLiked,
      });
      this.mklike = this.services
        .postRequestDoc('UpdateVendorLikes', data)
        .subscribe(
          (res) => {
            console.log(res);
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  lastTapTime: number = 0;
  delay: number = 300;
  doubletap = (count, index, trainingcenterid, isLiked) => {
    const currentTime = new Date().getTime();
    const elapsedTime = currentTime - this.lastTapTime;
    if (elapsedTime < this.delay) {
      let _obj = this;
      this.makeLikes(
        index,
        trainingcenterid,
        1,
        2,
        isLiked == 1 ? 'true' : 'false'
      );
      this.count += Number(count);
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        _obj.likedPopUpStatus = false;
      }, 1000);
    }
    this.lastTapTime = currentTime;

    // this.count += Number(count);
    // if (this.count == 1) {
    //   setTimeout(() => {
    //     this.count = 0;
    //   }, 500);
    // }
    // if (this.count == 2) {
    //   this.count = 0;
    //   this.makeLike(index, trainingcenterid, 1, 2);
    //   this.count = 0;
    //   this.dblClikedIndex = index;
    //   this.likedPopUpStatus = true;
    //   setTimeout(() => {
    //     this.likedPopUpStatus = false;
    //   }, 1000);
    // }
  };

  makeLikes(i, trainingcenterid, isLyk, from, isLiked) {
    try {
      let data = JSON.stringify({
        vendor_id: trainingcenterid,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Sports',
        isLiked: isLiked,
      });
      const UpdateVendorLikes = this.services
        .postRequestPhysioDoc('UpdateVendorLikes', data)
        .subscribe(
          (res) => {
            debugger;
            console.log(res);
            if (this.storeParticulerCategoryInfo[i].isLiked != 1) {
              this.storeParticulerCategoryInfo[i].likes_count =
                Number(this.storeParticulerCategoryInfo[i].likes_count) + 1;
            }
            this.storeParticulerCategoryInfo[i].isLiked = 1;
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  scroll() {
    this.content.scrollToBottom(1000);
  }
  scrolltop() {
    this.content.scrollToTop(100);
  }

  package_startdate: any;
  package_todate: any;
  dayBwhorking: any = [];
  selected_programdetails: any;
  async select_program() {
    debugger;

    this.showcoment = false;
    this.showbook = false;
    this.dateRange = null;
    this.dateRange1 = null;
    let alert = await this.modalCtrl.create({
      component: TrainingcenterProgramPage,
      cssClass: 'service-model1',
      componentProps: {
        selectprogram: this.particularCenterInfo.programList,
      },
    });
    alert.onDidDismiss().then((data) => {
      setTimeout(() => {
        this.scroll();
      }, 500);
      this.packageid = data.data.packageId;
      this.chooseprogramdetails(data.data.selected_program);
      this.getPatientBasicDetails();
      this.openOffInfo(data.data.indexval);
    });
    await alert.present();
  }

  chooseprogramdetails(data) {
    debugger;
    setTimeout(() => {
      this.todayDateDisable();
    }, 1000);
    setInterval(() => {
      this.todayDateDisable();
    }, 100);
    this.PackageFromAge = Number(data.trcr_age_from);
    this.PackageToAge = Number(data.trcr_age_to);
    // if (!data.trcr_age_from && !data.trcr_age_to) {
    //   this.filteredMembers = this.storeMembers;
    // } else {
    //   this.filteredMembers = this.storeMembers.filter((member) => {
    //     if (!member.age) {
    //       return false;
    //     }
    //     let ageInYears = 0;
    //     if (typeof member.age === 'string') {
    //       if (member.age.includes('yrs')) {
    //         ageInYears = parseInt(member.age); // Extract years as an integer
    //       } else if (member.age.includes('weeks')) {
    //         let weeks = parseInt(member.age); // Extract weeks as an integer
    //         ageInYears = weeks / 52; // Convert weeks to years
    //       } else {
    //         return false; // Skip if the format is unrecognized
    //       }
    //     } else {
    //       return false;
    //     }
    //     const isFromAgeValid = this.PackageFromAge || this.PackageFromAge === 0; // Allow 0 as a valid age
    //     const isToAgeValid = this.PackageToAge || this.PackageToAge === 0; // Allow 0 as a valid age
    //     return (
    //       (!isFromAgeValid || ageInYears >= this.PackageFromAge) &&
    //       (!isToAgeValid || ageInYears <= this.PackageToAge)
    //     );
    //   });
    // }
    // console.log(this.filteredMembers);

    this.packageAllAge = data.trcr_is_all_age;
    this.selected_programdetails = data;
    if (this.selected_programdetails != null) {
      this.selected_program = this.selected_programdetails;
      this.ProgramName = this.selected_programdetails.trcr_package_name;
      this.dealamt = this.selected_programdetails.dealOption;
      this.dealOption = this.dealamt;
      this.dealid = this.selected_programdetails.dealId;
      this.dealValue = this.selected_programdetails.dealValue;
      this.dealValue1 = this.selected_programdetails.dealValue;
      this.consamount = this.selected_programdetails.trcr_cost;
      this.package_startdate = this.selected_programdetails.trcr_package_from;
      this.package_todate = this.selected_programdetails.trcr_package_to;
      this.conssession = this.selected_programdetails.trcr_session;

      if (this.selected_programdetails.programdays == null) {
        this.dayBwhorking = [''];
        this.dayinweek = '';
      } else {
        this.dayBwhorking = this.selected_programdetails.programdays.split(',');
        let day = [];
        let fullday = [];
        this.dayBwhorking.forEach((i) => {
          day.push(this.weekDaysFull[Number(i) - 1].slice(0, 3));
          this.fulldayAvl.push(this.weekDaysFull[Number(i) - 1]);
        });

        this.dayinweek = day.join(', ');
      }
      this.clupWorkingHr();
      this.dayvalvheck();
    }
    if (this.package_startdate != null) {
      let startdate = new Date(this.package_startdate);
      let endDate = new Date(this.package_todate);
      this.optionsMulti = {
        pickMode: this.calenderMode,
        weekdays: [
          this.addCall.title411,
          this.addCall.title412,
          this.addCall.title413,
          this.addCall.title414,
          this.addCall.title415,
          this.addCall.title416,
          this.addCall.title417,
        ],
        disableWeeks: this.disabelDay,
        from: startdate,
        to: endDate,
      };
    }
  }
  async openNdPlay(type: any, path: any, mode: any, thumbnail: any) {
    if (this.storedPath === path) {
      this.showPopover(type, path, thumbnail);
    } else {
      this.storedPath = path;
      this.showPopover(type, path, thumbnail);
    }
  }

  private async showPopover(type: any, path: any, thumbnail: any) {
    const popover = await this.modalCtrl.create({
      component: MediapopupPage,
      componentProps: {
        Type: type,
        Path: path,
        ThumNail: thumbnail,
      },
      cssClass: 'media-popup',
    });
    await popover.present();
  }
  async uploadPhoto(event) {
    this.PatientProfileImage = '';
    const formData = new FormData();
    this.CameraFileUpload = true;
    formData.append('module_id', '66');
    formData.append('file', event.target.files[0]);
    formData.append('pathLocation', 'PROFILE/');

    this.services
      .imageUploadS3Bucket('admin/awsS3FileUpload', formData)
      .subscribe((response) => {
        console.log('resposeeehhhhhuploadimageblobToBinary', response);
        this.memProImg = response.filepath.Location;
        this.PatientProfileImage = response.filepath.privatePathUrl;
        console.log('this.memProImg', this.memProImg);
        setTimeout(async () => {
          this.CameraFileUpload = false;
        }, 500);
      });
  }

  async showaddress(address, myEvent) {
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: 'doctorBKFC',
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss();
    return await popover.present();
  }
  async viewMore(frm: any, cname: any) {
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: 'sports',
        showselectdate: this.slectedday,
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  async viewMoree(frm: any, cname: any) {
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        membername: this.members,
        memberidTT: this.membersId,
        memDetail: this.Selectedmemdetails,
      },
      cssClass: cname,
    });

    popover.onDidDismiss().then((data) => {
      this.totalBookingAmount =
        Number(this.members.length) * Number(this.consamount);
      if (!this.dealValue) {
        this.dealValue = 0;
      }

      if (this.dealOption == 'Amount') {
        this.dealType = 'KWD';
        this.finalPay =
          Number(this.totalBookingAmount) - Number(this.dealValue);
      } else if (this.dealOption == 'Percentage') {
        this.dealType = '%';
        this.finalPay =
          Number(this.totalBookingAmount) -
          (Number(this.totalBookingAmount) * Number(this.dealValue)) / 100;
      } else {
        this.finalPay = this.totalBookingAmount;
      }
    });
    return await popover.present();
  }

  dealserviceid: any;
  async offrDtils(myEvent, dealDet, i, trainerId, header, details) {
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        from: 'trainer',
        dealdetails: dealDet,
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss().then((data) => {
      if (data.data) {
        this.dealserviceid = data.data.datafortrainer.deal_service_type_id;
        this.selectProfile(trainerId, i, header, details);
      }
    });
    return await popover.present();
  }

  ratingSorting: any;
  ratingBasedSortingOrder: any;
  async showsort_page() {
    let popover = await this.modalCtrl.create({
      component: RatingSortpagePage,
      cssClass: 'rating_sort_page1',
      componentProps: {
        frm: 'training_center',
      },
    });
    popover.onDidDismiss().then((data) => {
      if (data.data.orderby == 'Rating') {
        this.storeParticulerCategoryInfo = [];
        this.ratingSorting = true;
        this.ratingBasedSortingOrder = data.data.orderWise;
        this.openClups(this.storeTriningCategoryId);
      } else if (data.data.orderby == 'Deal') {
      }
    });
    await popover.present();
  }

  nextcount1: any;

  loadrevcomments() {
    let requestdata = JSON.stringify({
      limit: 10,
      pageno: this.pagenorev,
      vendorid: this.particularCenterInfo.trainingCenterId,
      patientid: localStorage.getItem('patient_id'),
      vendortypeid: 7,
    });

    this.services
      .postRequest('getVendor_review', requestdata)
      .subscribe(async (res) => {
        if (res.data != null) {
          this.nextcount1 = res.data[res.data.length - 1].NextCount;
          for (let item of res.data) {
            this.revArr.push(item);
          }
          if (this.scrollEvent) {
            this.scrollEvent.target.complete();
          }
        }
      });
  }

  onIonInfinite(ev) {
    this.scrollEvent = ev;
    if (this.nextcount1 == 0) {
      ev.target.disabled = true;
    } else {
      this.pagenorev += 1;
      this.loadrevcomments();
    }
  }
  commonheadervalue: string = 'trainerheader';

  ngOnChanges() {
    this.commonheadervalue = 'commonbooking';
    if (this.showTypeofBooking == 'booking' || this.showTypeofBooking == '') {
      this.bookingList();
    } else if (this.showTypeofBooking == 'booking hitory') {
      this.bookingHis();
    }
  }

  async openAdvr() {
    if (this.isAdvrOpened) {
      return;
    }
    this.isAdvrOpened = true;
    window.localStorage['addType'] = 2;
    let popover = await this.modalCtrl.create({
      component: AdvertisementPage,
      componentProps: {
        addImg: this.addImg,
      },
      cssClass: this.dynClass,
    });
    popover.onDidDismiss().then((data) => {
      this.Addcheckvarible = false;
      if (!this.Addcheckvarible) {
        this.didScrollEvent(event);
      }
    });
    return await popover.present();
  }

  getAdd() {
    try {
      var min = new Date(new Date().setTime(new Date().getTime() + 3600000));
      let CT =
        min.toISOString().split('T')[0] +
        'T' +
        min.toTimeString().split(' ')[0];
      this.tymVal = CT;
      window.localStorage['DocADD'] = CT;

      let today = new Date().toISOString().split('T')[0];
      let data = JSON.stringify({
        vendor_type_id: 7,
        current_date: today,
      });
      this.services
        .postRequestGndrl('admin/get_current_advertisement', data)
        .subscribe(
          (res) => {
            if (res.data.length > 0) {
              this.Addcheckvarible = true;
              this.addImg = res.data[0].ad_path_name;
              if (res.data[0].ad_size == '2') {
                this.dynClass = 'advertisement1';
              } else if (res.data[0].ad_size == '1') {
                this.dynClass = 'advertisement2';
              }
              this.openAdvr();
            } else {
              this.Addcheckvarible = false;
              setTimeout(() => {
                this.didScrollEvent(event);
              }, 1000);
            }
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  async presentModal1() {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: 'SUCCESS!',
        messageContent: 'pay',
      },
    });
    modal.onDidDismiss().then(async (data) => {
      this.gopayment = true;
      this.payType = data.data;
      const loading = await this.loadingCtrl.create({
        message: 'Please wait we are redirecting you to the payment gateway',
      });
      if (data.data == '1') {
        await loading.present();

        this.payment
          .getsessionid(this.Name, this.Email, this.phoneno, this.finalPay)
          .then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFunction(res, 'MASTER');
          });
      } else if (data.data == '2') {
        await loading.present();
        this.payment
          .getKnetsessionid('', this.Email, this.phoneno, this.finalPay)
          .then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFunction(res, 'KNET');
          });
      } 
      // else if (data.data == '3') {
      //   await loading.present();
      //   this.payment
      //     .getApplesessionid(this.Name, this.Email, this.phoneno, this.finalPay)
      //     .then(async (res: any) => {
      //       await loading.dismiss();
      //       this.gatewayFunction(res, 'APPLE PAY');
      //     });
      // }

      this.payType = '';
      this.gopayment = false;
    });
    return await modal.present();
  }

  async showKnetPaymentDetals(data: any, msg: string) {
    const modal = await this.modalCtrl.create({
      component: knetPaymentDetailsPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: msg,
        messageContent: data,
      },
    });

    modal.onDidDismiss().then(async (data) => {
      if (msg === 'Payment Success Details') {
        this.router.navigate(['payment', { paymentstatus: 1 }]);
      }
    });
    return await modal.present();
  }

  async OpenMapMethod(
    Sports_name: any,
    Sports_address: any,
    Sports_lat_long: any
  ) {
    debugger;
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: Sports_name,
        clinic_address: Sports_address,
        clinic_lat_long: Sports_lat_long,
      },
    });
    modal.onDidDismiss().then((data) => {
      if (data.data == 'Map_Not_Show') {
        // this.ionViewWillEnter();
      }
    });
    return await modal.present();
  }
  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  openTerms() {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Sports');

    this.httpClient
      .get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        (response) => {
          if (response && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            this.terms_and_condition_file =
              response.data[lastIndex].Terms_and_conditions;
            const decryptedData = this.decryptContent(
              this.terms_and_condition_file
            );
            console.log('Decrypted data:', decryptedData);

            if (!decryptedData) {
              throw new Error('Decryption failed');
            }

            const content = htmlToPdfmake(decryptedData);
            console.log('PDF content:', content);

            if (!content || !Array.isArray(content)) {
              throw new Error('Invalid content structure');
            }

            const documentDefinition = {
              content: content,
              styles: {
                header: {
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
                  margin: [40, 0, 40, 0],
                },
                footerText: {
                  fontSize: 10,
                },
              },
              header: (currentPage, pageCount, pageSize) => {
                const modified_on = new Date();
                return {
                  text: ``,
                  alignment: 'left',
                  style: 'header',
                  color: '#510F30',
                  margin: [30, 40, 0, 0],
                };
              },
              footer: (currentPage, pageCount, pageSize) => {
                const modified_on = new Date();
                return {
                  margin: [40, 40, 40, 40],
                  columns: [
                    {
                      stack: [
                        {
                          text: `Page ${currentPage}/${pageCount}`,
                          alignment: 'right',
                          color: '#510F30',
                          style: 'footerText',
                        },
                      ],
                    },
                  ],
                };
              },
              pageMargins: [40, 70, 40, 180],
            };
            pdfMake
              .createPdf(documentDefinition)
              .getBlob(async (blob: Blob) => {
                console.log('PDF Blob:', blob);
                try {
                  const localBlob = new Blob([blob], {
                    type: 'application/pdf',
                  });
                  const fileName = `report_${new Date().getTime()}.pdf`;
                  await this.file
                    .writeFile(this.file.dataDirectory, fileName, localBlob, {
                      replace: true,
                    })
                    .then((fileEntry) => {
                      console.log('File entry:', fileEntry);
                      this.fileOpener
                        .open(fileEntry.nativeURL, 'application/pdf')
                        .then(() => console.log('File is opened'))
                        .catch((e) => console.log('Error opening file', e));
                    })
                    .catch((e) => console.log('Error writing file', e));
                } catch (error) {
                  console.error('Error uploading file', error);
                }
              });
          } else {
            console.error('Unexpected response format:', response);
          }
        },
        (error) => {
          console.error('Error:', error);
        }
      );
  }
  isRescheduleDates(dateOf: any): boolean {
    let foundValue; 
    foundValue = this.rescddate.find(
      (element) => String(element) === String(dateOf)
    );
    return foundValue;
  }

  tobeReschedule(dateOf: any): boolean {
    let foundValue; 
    foundValue = this.rescddays.find(
      (element) => String(element) === String(dateOf)
    );
    return foundValue;
  }

  myCompletedDates(dateOf: any): boolean {
    let foundValue; 
    foundValue = this.bookingsCompleted.find(
      (element) => String(element) === String(dateOf)
    );
    return foundValue;
  }
  myRemainingDates(dateOf: any): boolean { 
    let foundValue; 
    foundValue = this.bookingsRemaining.find(
      (element) => String(element) === String(dateOf)
    );
    return foundValue;
  }



}

function i(id: any, arg1: string, i: any) {
  throw new Error('Function not implemented.');
}

function center(
  center: any,
  id: any,
  arg2: string,
  i: (id: any, arg1: string, i: any) => void
) {
  throw new Error('Function not implemented.');
}
